/// <reference path="../lib/angular.min.js" />
//angular配置
(function (win) {
    //angular装饰器
    const decorators = {
        //装饰$http服务
        $http: ["$http", ["$delegate", "$q", "nativeService", "alertFrontService", function ($delegate, $q, nativeService, alertFrontService) {
            //创建一个立即执行的reject承诺
            var createRejectPromise = function (error) {
                var deferred = $q.defer();
                deferred.reject(error);
                return deferred.promise;
            }
            //ajax请求
            var ajaxRequest = function (httpData, isDealData) {
                return $delegate(httpData, isDealData)
                    .then(function (response) {
                        //d:{code:number, subCode: number, msg: string, data: T}
                        //d.code === 1000 代表请求信息正确
                        var d = response.data;
                        if (!isDealData || d.code != 1000) {
                            window.preprocessing && window.preprocessing.loading && window.preprocessing.loading.hide();
                            return createRejectPromise(d);
                        } else {
                            return d.data;
                        }
                    })
                    .catch(function (error) {
                        window.preprocessing && window.preprocessing.loading && window.preprocessing.loading.hide();
                        //异常提示优先级
                        //1. 后台请求获取的code码不为1000的请求错误信息
                        //2. 请求的网络异常信息
                        var msg = error.msg
                            || error.Msg
                            || (error.data && error.data.message)
                            || error.statusText
                            || "请求异常";

                        msg.indexOf("重复键") || msg.indexOf("更新") > -1 || msg.indexOf("PRIMARY") > -1 ? console.log(msg) : ($ && $.toast) ? ($.toast(msg)) : (console.log(msg));
                        //抛出异常，请求出现异常时，外层catch捕获
                        return createRejectPromise(error);
                    });
            }
            //$http包装器
            //httpData-原始数据参数,
            //isAuth-是否需要登录
            //isDealData 是否处理回来的数据
            var $httpDecorator = function (httpData, isAuth, isDealData) {
                if (isDealData == undefined) {
                    isDealData = true;
                }
                //alertFrontService.alert(httpData);
                //1.请求前都需要获取token
                //2.获取token成功 将token传入后台
                //3.获取token失败 如果isAuth为true 那么需要导航到登录页面,否则直接请求数据
                // /** 设置固定token**/
                // let headers = {
                //     'Authorization': String.prototype.concat('bearer ', localStorage.getItem('token'))
                // };
                // //请求头部添加认证信息
                // httpData.headers = Object.assign(httpData.headers || {}, headers);
                // return ajaxRequest(httpData, isDealData);


                return nativeService.token().then(function (_token) {
                    var headers = {
                        'Authorization': String.prototype.concat('bearer ', _token)
                    };
                    //请求头部添加认证信息
                    httpData.headers = Object.assign(httpData.headers || {}, headers);
                    return ajaxRequest(httpData, isDealData);
                }, function () {
                    //如果需要登录则跳转到登录页面
                    if (isAuth) {
                        return nativeService.login();
                    }
                        //不需要认证，则直接发起请求
                    else {
                        return ajaxRequest(httpData, isDealData);
                    }
                });
            }
            Object.assign($httpDecorator, $delegate);
            return $httpDecorator;
        }]]
    }
    var coreModule = angular.module("myApp", ["ngSanitize", "directivesModule", "endServicesModule", "filtersModule", "frontServicesModule", "h5ShareServicesModule"]);
    coreModule.config(["$provide", function ($provide) {
        for (var name in decorators) {
            $provide.decorator.apply($provide, decorators[name]);
        }
    }]);
    coreModule.config(['$compileProvider', function ($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|iosaccountingheadlines|androidtest|ftp|mailto|chrome-extension):/);
    }])
    window.coreModule = coreModule;
})(window);

/// <reference path="../lib/angular.min.js" />
(function (gc) {
    const apiHost = gc.apiHost;
    const mvcHost = gc.mvcHost;
    const headHost = gc.headHost;
    const shareHost = gc.shareHost;
    const htmlHost = gc.htmlHost;
    const fileHost = gc.fileHost;
    const appDownloadUrl = gc.appDownloadUrl;
    const toutiaoAppDownloadUrl = gc.toutiaoAppDownloadUrl;
    const toutiaoAppDownloadUrl1 = gc.toutiaoAppDownloadUrl1;
    const toutiaoAppDownloadUrl2 = gc.toutiaoAppDownloadUrl2;
    const toutiaoAppDownloadUrl3 = gc.toutiaoAppDownloadUrl3;
    const toutiaoAppDownloadUrlInYingYongBao= gc.toutiaoAppDownloadUrlInYingYongBao;
    const jmHost = gc.jmHost;
    const authHost = gc.authHost;
    const kjxyHost = gc.kjxyHost;

    angular.module("constantsModule", [])
    //apiUrls常量
    .constant("apiUrlsConstant", {
        //商品urls
        commodity: {
            product: apiHost + "/commodity/product",
            courseDetail: apiHost + "/commodity/courseDetail",
            areaData: htmlHost + "/data/AreaList.html",
            feight: apiHost + "/commodity/Freight",
            bookDetails: mvcHost + "/book/Details",
            bookCodeScan: mvcHost + "/BookQrCode/CoverQrCode",
            courseCodeScan: mvcHost + "/BookQrCode/ContentQrCode"
        },
        //我的订单urls
        myOrder: {
            //订单详情
            orderDetail: apiHost + "/myOrder/orderDetail",
            //空间订单详情
            spaceOrderDetail: apiHost + "/myOrder/spaceOrderDetail",
            //线下课程详情
            offlineCourseOrderDetail: apiHost + "/myOrder/offlineCourseOrderDetail",
            //录播课程详情
            recordedVideoCourse: apiHost + "/myOrder/recordedVideoCourse",
            //记录视频播放日志
            videoPlayed: apiHost + "/myOrder/videoPlayed",
            //确认收货
            verifyExpress: apiHost + "/myOrder/verifyExpress"
        },
        //新闻urls
        news: {
            //新闻详情从Cache里拿数据
            cacheDetail: apiHost + "/news/NewsDeatilCacheFirst",
            //新闻详情
            detail: apiHost + "/news/newsdetail",
            //相关推荐
            recommend: apiHost + "/news/relatedNews",
            //分享APP
            shareNews: apiHost + "/news/appNews",
            //文章分享过后弹出的推荐列表
            sharedNews: apiHost + "/news/RecommendNews"
        },
        //广告urls
        advertise: {
            articleContent: apiHost + "/advertisement/articleContent",//文章详情广告
            adH5: apiHost + "/advertisement/h5",//文章详情分享出去广告
            adClick: apiHost + "/advertisement/ad",//文章详情广告
        },
        //评论urls
        comment: {
            //3.1.3会废弃
            comments: apiHost + "/comment/comments",
            likes: apiHost + "/comment/like",
            colletion: apiHost + "/comment/collection",
            hotComments: apiHost + "/comment/commentsPage?type=1",
            //评论页  热门评论和最新评论
            commentsImCmt: apiHost + "/comment/commentsPage",
        },
        //搜索urls
        newsQuery: {
            hotSearch: apiHost + "/news/hotNewsSearch",
            keyWordSearch: apiHost + "/search/commonSearch",
        },
        //APP日志接口
        appLog: {
            //浏览日志接口
            viewLog: apiHost + "/AppLog/ShareLog",
        },
        //奖励领取接口
        reward: {
            //评论领金币
            commentGoldCoin: apiHost + "/Activities/CommentGoldCoin",
            //每天阅读三篇领金币
            readGoldCoin: apiHost + "/Activities/ReadArticlePerThreeGoldCoin",
            //阅读天眼查领权限
            readTycPoint: apiHost + "/Activities/ReadArticleTycPoint",
        },
    })
    .constant("AuthConstant", {
        auth: {
            //登录
            login: authHost + "/oauth/token",
            //注册
            register: authHost + "/api/Register",
            //发送验证码
            sendCode: headHost + "/Api/SendSMSForRegister.ashx",
            //确认验证码
            confimCode: jmHost + "/Me/CheckMobileUnAuth",
            //修改密码
            changePaw: headHost + "/api/ChangePwd.ashx",
        }
    })
    //其他非apiUrls
    .constant("otherUrlsConstant", {
        headImageUrl: headHost + '/App/Services/HeadPortrait.ashx?userSn=',
        getWXTicketUrl: shareHost + '/Api/GetTicket.ashx',
        qqService: 'mqqwpa://im/chat?chat_type=wpa&uin=2852273073&version=1&src_type=web&web_src=oicqzone.com'
    })
    .constant("webSiteConstant", {
        apiHost: apiHost,
        htmlHost: htmlHost,
        headHost: headHost,
        shareHost: shareHost,
        fileHost: fileHost,
        appDownload: appDownloadUrl,
        toutiaoAppDownload: toutiaoAppDownloadUrl,
        toutiaoAppDownload1: toutiaoAppDownloadUrl1,
        toutiaoAppDownload2: toutiaoAppDownloadUrl2,
        toutiaoAppDownload3: toutiaoAppDownloadUrl3,
        toutiaoAppDownloadInYingYongBao: toutiaoAppDownloadUrlInYingYongBao,
        jmHost: jmHost,
        authHost: authHost,
        kjxyHost: kjxyHost,
    })
    //正则表达式
    .constant("regExpressionsConstant", {
        date: /(\d{4})[-年\\//](\d{1,2})[-月\\//](\d{1,2})[日]?\s*(\d{1,2}):(\d{1,2}):(\d{1,2})/
    })
})(WEB_CONFIG);
/// <reference path="../lib/angular.min.js" />
//自定义指令
(function () {
    //组件名称以Directive结尾
    //组件的输入或输出属性以Prop结尾
    //组件属性传递方式@(单向传递)、=(双向传递)、&(方法传递)
    angular.module("directivesModule", ["nativeServicesModule", "endServicesModule"])
    //开关组件
    .directive("switchDirective", function () {
        return {
            template: '<span class="label-switch">\
                        <input type="checkbox" ng-checked="onProp == onCheckedValue" ng-disabled="disabledProp">\
                        <div class="checkbox" ng-click="contentClick()"></div>\
                    </span>',
            scope: {
                disabledProp: "=",
                onProp: "=",
                onCheckedValue: "@",
                onUncheckedValue: "@"
            },
            controller: ["$scope", function ($scope) {
                $scope.contentClick = function () {
                    if (!$scope.disabledProp) {
                        if ($scope.onCheckedValue == $scope.onProp) {
                            $scope.onProp = $scope.onUncheckedValue;
                        }
                        else {
                            $scope.onProp = $scope.onCheckedValue;
                        }
                    }
                }
            }],
            replace: true,
            restrict: "E"
        }
        })
        ////永久禁言组件
        .directive("forbiddenForeverDirective", function () {
            return {
                template: '<div ng-show="msgProp.showForever">\
                <div style="background:rgba(0,0,0,0.3);width:100%;height:100%;position:fixed;"></div>\
                <div style="background:white;width:260px;height:146px;position:absolute;left:50%;top:50%;margin-left:-130px;margin-top:-73px;z-index:999;border-radius:15px;">\
                    <div style="text-align:center;margin-top: 20px;width:70%;margin-left:15%">\
                        <span style="font-size:18px;"><b>{{msgProp.text}}</b></span>\
                    </div>\
                    <hr style="margin-top:20px;background-color:#eeeeee;height:1px;border:none;" />\
                    <div style="text-align:center;margin-top:10px;" ng-click="msgProp.showForever=false">\
                        <span style="font-size:18px;">知道了</span>\
                    </div>\
                </div>\
            </div>',
                scope: {
                    msgProp: "="
                },
                controller: ["$scope", function ($scope) {
                }],
                replace: true,
                restrict: "E"
            }
        })
        //禁言组件
        .directive("forbiddenDirective", function () {
            return {
                template: '<div ng-show="msgProp.show">\
                <div style="background:rgba(0,0,0,0.3);width:100%;height:100%;position:fixed;"></div>\
                <div style="background:white;width:260px;height:190px;position:absolute;left:50%;top:50%;margin-left:-120px;margin-top:-95px;z-index:999;border-radius:10px;">\
                    <div style="text-align:center;margin-top: 20px;margin-top: 30px;width:70%;margin-left:15%">\
                        <span style="font-size:18px;"><b>{{msgProp.text}}</b></span>\
                    </div>\
                    <div style="margin-top:10px;text-align:center;" >\
                        <span style="font-size:18px;">{{msgProp.dateText}}</span>\
                    </div >\
                    <hr style="margin-top:20px;background-color:#eeeeee;height:1px;border:none;" />\
                    <div style="text-align:center;margin-top:10px;" ng-click="msgProp.show=false">\
                        <span style="font-size:18px;">知道了</span>\
                    </div>\
                </div>\
            </div>',
                scope: {
                    msgProp: "=",
                },
                controller: ["$scope", function ($scope) { }],
                replace: true,
                restrict: "E"
            }
        })
    //返回组件
    .directive("backDirective", function () {
        return {
            scope: {},
            template: '<a class ="icon text-white pull-left text-black wd-6" ng-click="back()">\
                            <img src="../src/dist/img/common/back-top-icon.png" style="width:  0.875rem;" />\
                       </a>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.back = function () {
                    if (window.location.href.indexOf("newsDetail.html") > 0) {
                        nativeService.keyboardBarHide();
                        nativeService.back();
                    } else {
                        nativeService.back();
                    }
                }
            }],
            replace: true,
            restrict: "E"
        }
    })
    //内部页面返回组件
    .directive("backInnerDirective", function () {
        return {
            scope: {},
            template: '<a class ="icon text-white pull-left text-black back">\
                            <img src="../src/dist/img/common/back-top-icon.png" style="width:  0.875rem;" />\
                       </a>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
            }],
            replace: true,
            restrict: "E"
        }
    })
    //分享出去的文章顶部推荐图文
    .directive("topAdDirective", function () {
        var fun = window.onload || function () { };
        window.onload = function () {
            fun(); var oldTop = 0;
            var topAd = document.getElementsByClassName("ad-inner")[0], content = document.getElementsByClassName("content")[0];
            function isScrollDown() { var top = content.scrollTop, result = top > oldTop; oldTop = top; return result; }
            function disapper() {
                if (topAd.offsetTop == 0) {
                    topAd.classList.remove("appear"); topAd.classList.add("disapper");
                }
            }
            function appear() {
                if (topAd.offsetTop <= -30) {
                    topAd.classList.remove("disapper"); topAd.classList.add("appear");
                }
            }
            content.onscroll = function () {
                if (content.scrollTop <= 60) { appear(); return; }
                if (isScrollDown()) { disapper(); } else { appear(); }
            }
        }
        return {
            scope: true,
            template: '<div id="topAd" class="top-ad"><div class="ad-inner" ng-click="adClick()" style="top:0px"><table><tr><td class="l"><div class="ad-pic"></div></td>\
                <td class="m"><div class="ad-text-up">柠檬云记账</div><div class="ad-text-down">百万会计必备神器</div></td>\
                <td class="r"><span class="btn-open"></span></td></tr></table></div></div>',
            controller: ["$scope", "webSiteConstant", function ($scope, webSiteConstant) {
                $scope.adClick = function () { window.location.href = webSiteConstant.appDownload; };
            }],
            restrict: "E",
            replace: true
        }
    })
    //会计头条分享出去的文章顶部推荐图文
    .directive("topAd2Directive", function () {
        var fun = window.onload || function () { };
        window.onload = function () {
            fun(); var oldTop = 0;
            var topAd = document.getElementsByClassName("ad-inner")[0], content = document.getElementsByClassName("content")[0];
            function isScrollDown() { var top = content.scrollTop, result = top > oldTop; oldTop = top; return result; }
            function disapper() {
                if (topAd.offsetTop == 0) {
                    topAd.classList.remove("appear"); topAd.classList.add("disapper");
                }
            }
            function appear() {
                if (topAd.offsetTop <= -30) {
                    topAd.classList.remove("disapper"); topAd.classList.add("appear");
                }
            }
            content.onscroll = function () {
                if (content.scrollTop <= 60) { appear(); return; }
                if (isScrollDown()) { disapper(); } else { appear(); }
            }
        }
        return {
            scope: true,
            template: '<div id="topAd" class="top-ad2"><a class="ad-inner" ng-href="{{link}}" ng-click="adClick()" style="top:0px"><table><tr><td class="l"><div class="ad-pic"></div></td>\
                <td class="m"><div class="ad-text-up">会计头条</div><div class="ad-text-down">专业、及时、有料的会计阅读应用</div></td>\
                <td class="r"><span class="btn-open"></span></td></tr></table></a></div>',
            controller: ["$scope", "webSiteConstant", "locationFrontService", function ($scope, webSiteConstant, locationFrontService) {
                $scope.link = (function () {
                    var u = navigator.userAgent;
                    var isIOS = u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    var isAndroid = u.match(/Android/);
                    var link = webSiteConstant.toutiaoAppDownload;
                    if (isIOS) {
                        link = "iosaccountingheadlines://iOSAccountingHeadlines?" + location.href;
                    } else if (isAndroid) {
                        link = "androidtest://android/article?articleid=" + locationFrontService.queryString("ArticleId");
                    }
                    return link;
                })();
                $scope.adClick = function () {
                    
                    setTimeout(function () {
                        window.open(webSiteConstant.toutiaoAppDownload, '_self')
                    }, 2000);

                    return true;
                };
            }],
            restrict: "E",
            replace: true
        }
    })
    //分享出去的书籍/课程页面顶部推荐图文
    .directive("proTopAdDirective", function () {
        var fun = window.onload || function () { };
        window.onload = function () {
            fun(); var oldTop = 0;
            var topAd = document.getElementsByClassName("ad-inner")[0], content = document.getElementsByClassName("content")[0];
            function isScrollDown() { var top = content.scrollTop, result = top > oldTop; oldTop = top; return result; }
            function disapper() {
                if (topAd.offsetTop == 0) {
                    topAd.classList.remove("appear"); topAd.classList.add("disapper");
                }
            }
            function appear() {
                if (topAd.offsetTop <= -30) {
                    topAd.classList.remove("disapper"); topAd.classList.add("appear");
                }
            }
            content.onscroll = function () {
                if (content.scrollTop <= 60) { appear(); return; }
                if (isScrollDown()) { disapper(); } else { appear(); }
            }
        }
        return {
            scope: true,
            template: '<div id="topAd" class="top-ad"><div class="ad-inner" ng-click="adClick()" style="top:0px"><table><tr><td class="l"><div class="ad-pic"></div></td>\
                <td class="m"><div class="ad-text">柠檬云记账</div></td><td class="r"><span class="btn-open"></span></td></tr></table></div></div>',
            controller: ["$scope", "webSiteConstant", function ($scope, webSiteConstant) {
                $scope.adClick = function () { window.location.href = webSiteConstant.appDownload; };
            }],
            restrict: "E",
            replace: true
        }
    })
    //分享出去的页面底部添加“去看看”
    .directive("sharedBotDirective", function () {
        return {
            scope: true,
            template: '<div class="content-block shared-art-bottom" ng-click="adClick()"><div class="space1"></div>\
                <div class="suggest-text">没有找到想要的？<br/>打开柠檬云记账看看吧～</div>\
                <div class="space2"></div><div class="btn-see"></div></div>',
            controller: ["$scope", "nativeService", "webSiteConstant",
                function ($scope, nativeService, webSiteConstant) {
                    $scope.adClick = function () {
                        window.location.href = webSiteConstant.appDownload;
                    };
                }],
            restrict: "E",
            replace: true
        }
    })
    //(会计头条)分享出去的页面底部添加“去看看”
    .directive("sharedBot2Directive", function () {
        return {
            scope: true,
            template: '<div class="content-block shared-art2-bottom" ng-click="adClick()"><div class="space1"></div>\
                <div class="suggest-text">没有找到想要的？<br/>打开会计头条App看看吧～</div>\
                <div class="space2"></div><div class="btn-see">立即下载</div></div>',
            controller: ["$scope", "nativeService", "webSiteConstant",
                function ($scope, nativeService, webSiteConstant) {
                    $scope.adClick = function () {
                        window.location.href = webSiteConstant.toutiaoAppDownload;
                    };
                }],
            restrict: "E",
            replace: true
        }
    })
    //分享出去的商品页面底部图文推荐
    .directive("productAdDirective", function () {
        return {
            scope: {
                picSrcProp: '=',
                priceProp: '=',
                textProp: '='
            },
            template: '<div class="bot-ad"><table><tr><td><div class="pic-box"><img ng-src="{{picSrcProp}}"/></div></td>\
                <td><span class="ad-text-up">【限时优惠】</span><span class="ad-price">￥{{priceProp}}</span><br/>\
                <span class="ad-text-down">{{textProp}}</span></td><td>\
                <span class="btn-buy" ng-click="adClick()">去购买</span></td></tr></table></div>',
            controller: ["$scope", "nativeService", "webSiteConstant", function ($scope, nativeService, webSiteConstant) {
                $scope.adClick = function () {
                    window.location.href = webSiteConstant.appDownload;
                };
            }],
            restrict: "E",
            replace: true
        }
    })
    //弹出分享菜单的按钮
    .directive("shareMenuButtonDirective", function () {
        return {
            scope: {
                //如果是分享{title, descr, url, thumbURL}
                shareParamProp: '=',
                //default|bottom
                positionProp: '@',
                isHideTextProp: "@"
            },
            template: function (ele, attrs) {
                var html = "";
                switch (attrs["positionProp"]) {
                    case "bottom":
                        html = '<span class="switch share-switch" ng-click="shareMenuClick()">\
                                    <input type="checkbox" />\
                                    <span class ="switch-label">{{isHideTextProp ? \'\': \'分享\'}}</span>\
                                </span>'
                        break;
                    case "top":
                        html = '<a class ="pull-right shareImgPosition" ng-click="shareMenuClick()">\
                                    <img src="../src/dist/img/common/share.png" class="shareImg">\
                                </a>';
                        break;
                    default:
                        html = '<a class ="icon text-white pull-right btn-share-right-top" ng-click="shareMenuClick()">分享</a>';
                }
                return html;
            },
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.shareMenuClick = function () {
                    if ($scope.shareParamProp) {
                        nativeService.shareMenu($scope.shareParamProp);
                    }
                }
            }],
            replace: true,
            restrict: "E"
        }
    })

    //头部搜索按钮
    .directive("searchButtonDirective", function () {
        return {
            scope: {},
            template: '<a class ="icon text-white pull-right" href="../ftlib/ftSearch.html" >\
                         <img src="../src/dist/img/common/ft-search.png" style="width: 1rem;height:17px;width:17px;" />\
                       </a>',
            replace: true,
            restrict: "E"
        }
    })

    //客服按钮
    .directive("customerServicesButtonDirective", function () {
        return {
            scope: {
                //top|bottom
                positionProp: '@'
            },
            template: function (ele, attrs) {
                switch (attrs["positionProp"]) {
                    case "bottom":
                        return '<a class="switch customer-services-switch d-flex flex-column" ng-click="qqService()">\
                                    <input type="checkbox" />\
                                    <span class="switch-label"></span>\
                                    <span>客服</span>\
                                </span>'
                        break;
                    default:
                        return '<a class="icon text-white pull-right" ng-click="qqService()">\
                                    <img src="../src/dist/img/common/customer-services-green.png" style="width: 1rem; " />\
                                </a>'
                }
            },
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.qqService = function () {
                    nativeService.qqService();
                }
            }],
            replace: true,
            restrict: "E"
        }
    })

    //页面头部组件
    .directive("headerDirective", function () {
        return {
            //titleProp: 'header中间标题'
            //menuProp: 'shareMenu'(分享菜单)|'customerServices(客服)'|'searchButton(法规库搜索按钮)|'，根据传入的值显示对应的菜单
            //menuParamProp，右侧菜单单击事件传入参数
            scope: {
                titleProp: '@',
                menuProp: '@',
                //如果是分享{title, descr, url, thumbURL}
                menuParamProp: '='
            },
            template: '<header class="bar bar-nav web-none web-message-none d-flex align-items-center" ng-switch="menuProp">\
                            <back-directive></back-directive>\
                            <h1 class ="title text-black header-title" style="position:static;" ng-cloak>{{titleProp}}</h1>\
                            <search-button-directive class="d-flex align-self-stretch align-items-center" ng-switch-when="searchButton"></search-button-directive>\
                            <share-menu-button-directive class="d-flex align-self-stretch align-items-center" share-param-prop="menuParamProp" ng-switch-when="shareMenu"></share-menu-button-directive>\
                            <customer-services-button-directive class="d-flex align-self-stretch align-items-center" ng-switch-when="customerServices"></customer-services-button-directive>\
                       </header>',
            replace: true,
            restrict: 'E'
        };
    })
    //课程页面头部组件
    .directive("courseHeaderDirective", function () {
        return {
            scope: {
                menuProp: '@',
                menuParamProp: '='
            },
            template: '<header class="bar bar-nav web-none web-message-none d-flex align-items-center course-bar" ng-switch="menuProp">\
                            <span class="icon back" ng-click="back()"></span>\
                            <span class="icon share" ng-click="share()"></span>\
                       </header>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.back = function () { nativeService.back(); }
                $scope.share = function () {
                    if ($scope.menuParamProp) {
                        nativeService.shareMenu($scope.menuParamProp);
                    }
                }
            }],
            replace: true,
            restrict: 'E'
        };
    })
    //页面头部组件
    .directive("headerRecordedVideoCourseDirective", function () {
        return {
            //titleProp: 'header中间标题'
            //menuProp: 'shareMenu'(分享菜单)|'customerServices(客服)'|'searchButton(法规库搜索按钮)|'，根据传入的值显示对应的菜单
            //menuParamProp，右侧菜单单击事件传入参数
            scope: {
                titleProp: '@',
                urlProp: '@'
            },
            template: '<header class="bar bar-nav web-none web-message-none d-flex align-items-center" style="background-color: white;color: black;" ng-switch="menuProp">\
                            <back-directive></back-directive>\
                            <h1 class ="title text-black header-title" style="position:static;" ng-cloak>{{titleProp}}</h1>\
                            <a class="color-info font-15" style="white-space: nowrap;" navigate-to-inner-bar-webview-directive="{{urlProp}}">订单详情</a>\
                       </header>',
            replace: true,
            restrict: 'E'
        };
    })
    //内部页面头部组件
    .directive("headerInnerDirective", function () {
        return {
            //titleProp: 'header中间标题'
            //menuProp: 'shareMenu'(分享菜单)|'customerServices(客服)'，根据传入的值显示对应的菜单
            //menuParamProp，右侧菜单单击事件传入参数
            scope: {
                titleProp: '@',
                menuProp: '@',
                //如果是分享{title, descr, url, thumbURL}
                menuParamProp: '=',
                hrefParamProp: '='
            },
            template: '<header class="bar bar-nav" style="background-color: white;color: black;" ng-switch="menuProp">\
                            <back-inner-directive></back-inner-directive>\
                            <search-button-directive  ng-switch-when="searchButton"></search-button-directive>\
                            <share-menu-button-directive share-param-prop="menuParamProp" ng-switch-when="shareMenu"></share-menu-button-directive>\
                            <customer-services-button-directive ng-switch-when="customerServices"></customer-services-button-directive>\
                            <h1 class ="title text-black" ng-cloak>{{titleProp}}</h1>\
                       </header>',
            replace: true,
            restrict: 'E'
        };
    })

    //分享组件(微信好友、朋友圈、QQ好友)
    .directive("sharesDirective", function () {
        return {
            scope: {
                shareParamProp: '=',
                hideLabelProp: '@'
            },
            template: '<section class="share-section  mtb-6 content-block web-none">\
                            <div class ="share-label d-flex" ng-if="!hideLabelProp">\
                              <span style="width:100%;text-align:center;">分享到</span>\
                            </div>\
                            <div class="share-list">\
                                <div class ="share-item" ng-click="shareClick(1)">\
                                    <img class ="share-item-img" src="../src/dist/img/common/wechat.png" />\
                                    <span class="share-item-text">微信好友</span>\
                                </div>\
                                <div class ="share-item" ng-click="shareClick(2)">\
                                    <img class ="share-item-img" src="../src/dist/img/common/wechat-zone.png" />\
                                    <span class="share-item-text">微信朋友圈</span>\
                                </div>\
                                <div class ="share-item" ng-click="shareClick(3)">\
                                    <img class ="share-item-img" src="../src/dist/img/common/qq.png" />\
                                    <span class="share-item-text">QQ好友</span>\
                                </div>\
                            </div>\
                        </section>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                //args(外部传入对象):{title, descr, url, thumbURL, type}
                $scope.shareClick = function (type) {
                    if ($scope.shareParamProp) {
                        $scope.shareParamProp.type = type;
                        nativeService.share($scope.shareParamProp);
                    }
                }
            }],
            replace: true,
            restrict: 'E'
        };
    })

   //
         .directive("articleDynDirective", function () {
             return {
                 scope: {
                     articleProp: "=",
                     isLikeProp: "=",
                 },
                 template: '<div class="article">\
                            <div class ="article-footer content-block justify-content-center" style="margin-top:2.5rem;">\
                                <article-likes-directive likes-param-prop="articleProp" is-like-prop="isLikeProp"></article-likes-directive>\
                            </div>\
                           </div>',
                 replace: true,
                 restrict: 'E'
             };
         })

    //文章组件
    .directive("articleDirective", function ($compile) {
        return {
            scope: {
                //{itemType,itemSn, name, date, author, source, image, body, readTimes, likeTimes}
                articleProp: "=",
                isLikeProp: "=",
                inWebProp: "=",
                isToutiao: "="
            },
            template: '<article id="detail" class="article">\
                            <div class="jump-tip"><span></span>下拉返回到列表</div>\
                            <h5 class ="article-title content-block" ng-cloak>\
                                {{articleProp.name}}\
                            </h5>\
                            <div class ="sub-title">\
                                <div class ="face"><img ng-src="{{articleProp.authorFace}}"/></div>\
                                <div class ="name">{{articleProp.authorName}}</div>\
                                <div class ="date">{{articleProp.date}}</div>\
                                <div class ="btn-follow" ng-if="inWebProp.isInWeb" ng-click="toggleOrCode()" >\
                                    <div class ="or-code">\
                                        <img src="{{articleProp.authorOrCode}}"/>\
                                        <div class="corner"></div>\
                                    </div>\
                                </div>\
                            </div>\
                            <div ng-if="!inWebProp.isInWeb" class="adjust-blank"></div>\
                            <div class ="article-body content-block">\
                                <div class ="text-center" ng-if="articleProp.image">\
                                    <img class ="responsive-img" ng-src="{{articleProp.image}}" />\
                                </div>\
                                <div class="article-body-html"></div>\
                                <div ng-if="inWebProp.isInWeb" ng-class="btnClass">\
                                    <div class ="icon-arrow" ng-click="showAllContent()"></div>\
                                    <div class="btn-view" ng-click="showAllContent()">点击展开全文</div>\
                                </div>\
                            </div>\
                        </article>',
            controller: ["$scope", "nativeService", "webSiteConstant", function ($scope, nativeService, webSiteConstant) {
                
                $scope.showMagnifiedPic = nativeService.showMagnifiedPic;
                $scope.changeBarViewsState = nativeService.changeBarViewsState;
                $scope.saveImgToClient = nativeService.saveImgToClient;
                $scope.showOtherPageInMobile = nativeService.callNativeWebviewWithURLWithNaviBar;
                $scope.btnClass = "view-in-app";
                var downloadUrl = webSiteConstant.appDownload;
                if ($scope.isToutiao) {
                    downloadUrl = webSiteConstant.toutiaoAppDownload;
                    $scope.btnClass = "view-in-app view-in-toutiao";
                }
                $scope.toggleOrCode = function () {
                    //var codePic = $(".btn-follow .or-code");
                    //if (codePic.css("display") == "block") { codePic.hide(); } else { codePic.show(); }
                    window.location.href = downloadUrl;
                }
                $scope.viewInApp = function () { window.location.href = downloadUrl; };
                $scope.showAllContent = function () {
                    var sab = document.getElementsByClassName("shared-article-body")[0];
                    sab.style.height = "auto"; sab.removeChild(sab.getElementsByClassName("content-mask")[0]);
                    document.getElementsByClassName("view-in-app")[0].style.display = "none";
                }
            }],
            link: function (scope, ele, attr) {
                var shadow = document.createElement("div");
                shadow.setAttribute("class", "article-img-shadow");
                var countDiv = document.createElement("div");
                countDiv.setAttribute("class", "article-img-count");
                shadow.appendChild(countDiv);
                var contentDiv = document.createElement("div");
                contentDiv.setAttribute("class", "article-img-content");
                shadow.appendChild(contentDiv);
                var saveDiv = document.createElement("div");
                saveDiv.setAttribute("class", "article-img-save");
                saveDiv.innerHTML = "保存";
                if (preprocessing.device.version) {
                    shadow.appendChild(saveDiv);
                }
                document.body.appendChild(shadow);
                $(ele[0]).find(".article-body-html").on("click", "a", function (ev) {
                    var oEvent = ev || event;
                    oEvent.cancelBubble = true;
                    oEvent.stopPropagation();
                    oEvent.preventDefault();
                    if (!preprocessing.device.inWeb) {
                        scope.showOtherPageInMobile({ url: this.href });
                    } else {
                        window.location.href = this.href;
                    }
                });

                $(ele[0]).find(".article-body-html").on("click", "img", function () {
                    if (preprocessing.device.compareVersion && preprocessing.device.compareVersion("3.0.7")) {
                        var imgs = $(ele[0]).find(".article-body-html img");
                        var index = 0;
                        var urlArr = [];
                        for (var i = 0; i < imgs.length; i++) {
                            if (this.src == imgs[i].src) {
                                index = i;
                            }
                            urlArr.push(imgs[i].src);
                        }
                        scope.showMagnifiedPic({ urls: urlArr, index: index });
                    }
                    else {
                        var thisimg = this;
                        scope.changeBarViewsState({ state: 'false' }).then(function () {
                            var imgs = $(ele[0]).find(".article-body-html img");
                            var count = imgs.length;
                            var index = 1;
                            for (var i = 0; i < count; i++) {
                                if (thisimg.src == imgs[i].src) {
                                    index = i + 1;
                                    break;
                                }
                            }
                            countDiv.innerHTML = index + "/" + count;
                            var currentImg = thisimg.cloneNode();
                            currentImg.removeAttribute("style");
                            currentImg.style.left = "0px";
                            mathTop(currentImg);
                            contentDiv.appendChild(currentImg);
                            var prevImg;
                            var nextImg;
                            if (index != 1) {
                                prevImg = imgs[index - 2].cloneNode();
                                prevImg.removeAttribute("style");
                                prevImg.style.left = -document.body.clientWidth + "px";
                                mathTop(prevImg);
                                contentDiv.appendChild(prevImg);
                            }
                            if (index != count) {
                                nextImg = imgs[index].cloneNode();
                                nextImg.removeAttribute("style");
                                nextImg.style.left = document.body.clientWidth + "px";
                                mathTop(nextImg);
                                contentDiv.appendChild(nextImg);
                            }
                            shadow.style.display = "block";
                            $(shadow).animate({ opacity: "1", filter: "alpha(opacity=100%)" }, "fast");
                            var dragging = false;//是否正在准备拖动
                            var switching = false;//是否正在进行图片切换
                            var moving = false;//是否正在拖动
                            var scrolling = false;
                            var zooming = false;//是否正在进行拉伸
                            var diffX = 0;//拖动时的初始X坐标
                            var diffY = 0;
                            var diffDate = Date.now();//拖动时的初始时间
                            var currentLeft = 0;//拖动时当前的left值
                            var dblclicking1 = false;
                            var dblclicking2 = false;//这两个值用于避免触发双击事件时触发up事件
                            var initialLength = 0;//拉伸时的初始间距
                            var distroying = false;//是否正在销毁
                            var mousedown = function (event) {
                                //event.preventDefault();
                                if (switching)
                                    return;
                                if (event.touches.length > 1 && !moving && !scrolling) {
                                    dragging = false;
                                    zooming = true;
                                    initialLength = Math.sqrt(Math.pow(event.touches[0].clientX - event.touches[1].clientX, 2) + Math.pow(event.touches[0].clientY - event.touches[1].clientY, 2));
                                }
                                else {
                                    dragging = true;
                                    diffX = event.touches[event.touches.length - 1].clientX;
                                    diffY = event.touches[event.touches.length - 1].clientY;
                                    diffDate = Date.now();
                                    currentLeft = currentImg.style.left.replace("px", "") * 1;
                                    if (prevImg) {
                                        prevImg.style.left = -prevImg.width + currentLeft + "px";
                                        prevImg.style.top = (document.body.clientHeight - prevImg.height) / 2 + "px";
                                    }
                                    if (nextImg) {
                                        nextImg.style.left = currentImg.width + currentLeft + "px";
                                        nextImg.style.top = (document.body.clientHeight - nextImg.height) / 2 + "px";
                                    }
                                }
                            };
                            var mousemove = function (event) {
                                if (dragging) {
                                    var clientX = event.touches[event.touches.length - 1].clientX;
                                    var clientY = event.touches[event.touches.length - 1].clientY;
                                    if (!moving && currentImg.height > document.body.clientHeight && Math.abs(clientY - diffY) >= 5) {
                                        scrolling = true;
                                    }
                                    else if (!scrolling && Math.abs(clientX - diffX) >= 5) {
                                        moving = true;
                                        event.preventDefault();
                                        if (index == 1 && clientX - diffX > 0 && currentImg.style.left.replace("px", "") * 1 >= 0) {
                                            currentImg.style.left = "0px";
                                            diffX = event.touches[event.touches.length - 1].clientX - 5;
                                        }
                                        else if (index == count && clientX - diffX < 0 && currentImg.width + currentImg.style.left.replace("px", "") * 1 <= document.body.clientWidth) {
                                            currentImg.style.left = document.body.clientWidth - currentImg.width + "px";
                                            diffX = event.touches[event.touches.length - 1].clientX + 5;
                                        }
                                        else {
                                            if (prevImg) {
                                                prevImg.style.left = -prevImg.width + currentLeft + (clientX - diffX) + "px";
                                            }
                                            if (nextImg) {
                                                nextImg.style.left = currentImg.width + currentLeft + (clientX - diffX) + "px";
                                            }
                                            currentImg.style.left = currentLeft + (clientX - diffX) + "px";
                                        }
                                    }
                                }
                                if (zooming) {
                                    var currentLength = Math.sqrt(Math.pow(event.touches[0].clientX - event.touches[1].clientX, 2) + Math.pow(event.touches[0].clientY - event.touches[1].clientY, 2));
                                    var diffLength = currentLength - initialLength;
                                    if (diffLength == 0)
                                        return;
                                    if (currentImg.style.width.replace("%", "") * 1 >= 180 && diffLength > 0)
                                        return;
                                    if (currentImg.style.width.replace("%", "") * 1 <= 100 && diffLength < 0)
                                        return;
                                    initialLength = currentLength;
                                    var centerX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
                                    var currentProportion = currentImg.style.width.replace("%", "") * 1 + diffLength * 100 / document.body.clientWidth;
                                    if (currentProportion >= 180)
                                        currentProportion = 180;
                                    if (currentProportion <= 100)
                                        currentProportion = 100;
                                    var left = currentImg.style.left.replace("px", "") * 1 - ((document.body.clientWidth * currentProportion / 100) - currentImg.width) * (centerX / document.body.clientWidth);
                                    if (left >= 0)
                                        left = 0;
                                    if (document.body.clientWidth * currentProportion / 100 + left <= document.body.clientWidth)
                                        left = -document.body.clientWidth * (currentProportion - 100) / 100;
                                    var height = (currentImg.height / (currentImg.style.width.replace("%", "") * 1 / 100)) * currentProportion / 100;
                                    if (height <= document.body.clientHeight)
                                        currentImg.style.top = (document.body.clientHeight - height) / 2 + "px";
                                    currentImg.style.width = currentProportion + "%";
                                    currentImg.style.left = left + "px";
                                }
                            };
                            var mouseup = function (event) {
                                if (dragging) {
                                    if (switching)
                                        return;
                                    if (event.touches.length > 0)
                                        return;
                                    dragging = false;
                                    moving = false;
                                    scrolling = false;
                                    var width = document.body.clientWidth;
                                    var left = currentImg.style.left.replace("px", "") * 1;
                                    var isSwipe = (Date.now() - diffDate) <= 250 && Math.abs(event.changedTouches[0].clientX - diffX) >= 50;
                                    if (((isSwipe && left > 45) || left > (width * 2 / 3)) && index != 1) {
                                        switching = true;
                                        $(currentImg).animate({ left: width }, 200);
                                        $(nextImg).animate({ left: width }, 200);
                                        $(prevImg).animate({ left: 0 }, 200, function () {
                                            index--;
                                            countDiv.innerHTML = index + "/" + count;
                                            currentImg.style.width = "100%";
                                            if (nextImg)
                                                nextImg.remove();
                                            nextImg = currentImg;
                                            currentImg = prevImg;
                                            if (index == 1) {
                                                prevImg = undefined;
                                            }
                                            else {
                                                prevImg = imgs[index - 2].cloneNode();
                                                prevImg.removeAttribute("style");
                                                prevImg.style.left = -width + "px";
                                                mathTop(prevImg);
                                                contentDiv.appendChild(prevImg);
                                            }
                                            switching = false;
                                        });
                                    }
                                    else if (((isSwipe && left + 45 + currentImg.width * 1 < width) || left + currentImg.width * 1 < (width / 3)) && index != count) {
                                        switching = true;
                                        $(currentImg).animate({ left: -currentImg.width }, 200);
                                        $(prevImg).animate({ left: -width }, 200);
                                        $(nextImg).animate({ left: 0 }, 200, function () {
                                            index++;
                                            countDiv.innerHTML = index + "/" + count;
                                            currentImg.style.width = "100%";
                                            if (prevImg)
                                                prevImg.remove();
                                            prevImg = currentImg;
                                            currentImg = nextImg;
                                            if (index == count) {
                                                nextImg = undefined;
                                            }
                                            else {
                                                nextImg = imgs[index].cloneNode();
                                                nextImg.removeAttribute("style");
                                                nextImg.style.left = width + "px";
                                                mathTop(nextImg);
                                                contentDiv.appendChild(nextImg);
                                            }
                                            switching = false;
                                        });
                                    }
                                    else {
                                        if (event.changedTouches[0].clientX == diffX && event.changedTouches[0].clientY == diffY) {
                                            setTimeout(function () {
                                                if (!dblclicking1 && !dblclicking2) {
                                                    $(shadow).animate({ opacity: "0", filter: "alpha(opacity=0%)" }, "fast", function () {
                                                        shadow.style.display = "none";
                                                        scope.changeBarViewsState({ state: 'true' }).then();
                                                    });
                                                    $(currentImg).remove();
                                                    if (prevImg)
                                                        $(prevImg).remove();
                                                    if (nextImg)
                                                        $(nextImg).remove();
                                                }
                                                else {
                                                    if (dblclicking1) {
                                                        dblclicking1 = false;
                                                    }
                                                    else {
                                                        dblclicking2 = false;
                                                    }
                                                }
                                            }, 300);
                                        }
                                        else {
                                            if (currentImg.style.width == "100%") {
                                                $(currentImg).animate({ left: 0 }, 200);
                                                if (prevImg)
                                                    $(prevImg).animate({ left: -width }, 200);
                                                if (nextImg)
                                                    $(nextImg).animate({ left: width }, 200);
                                            }
                                            else {
                                                if (left > 0) {
                                                    $(currentImg).animate({ left: 0 }, 200);
                                                    if (prevImg)
                                                        $(prevImg).animate({ left: -width }, 200);
                                                    if (nextImg)
                                                        $(nextImg).animate({ left: currentImg.width }, 200);
                                                }
                                                else {
                                                    if (left + currentImg.width < width) {
                                                        $(currentImg).animate({ left: width - currentImg.width }, 200);
                                                        if (prevImg)
                                                            $(prevImg).animate({ left: -currentImg.width }, 200);
                                                        if (nextImg)
                                                            $(nextImg).animate({ left: width }, 200);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    diffX = 0;
                                }
                                if (zooming) {
                                    zooming = false;
                                }
                            };
                            var dblclick = function (event, point) {
                                dblclicking1 = true;
                                dblclicking2 = true;
                                if (currentImg.style.width == "100%" || currentImg.style.width == "") {
                                    var width = currentImg.width * 1;
                                    var left = point.x * 0.5;
                                    var top = (document.body.clientHeight - currentImg.height * 1.6) / 2;
                                    if (top < 0)
                                        top = 0;
                                    $(currentImg).animate({ width: "160%", left: -left, top: top }, 100);
                                }
                                else {
                                    var top = (document.body.clientHeight - currentImg.height / (currentImg.style.width.replace("%", "") * 1 / 100)) / 2;
                                    if (top < 0)
                                        top = 0;
                                    $(currentImg).animate({ width: "100%", left: 0, top: top }, 100);
                                }
                            }
                            contentDiv.ontouchstart = mousedown;
                            contentDiv.ontouchmove = mousemove;
                            contentDiv.ontouchend = mouseup;
                            $(contentDiv).off("doubleTap").on("doubleTap", dblclick);
                            $(saveDiv).off("click").on("click", function (event) {
                                event.stopPropagation();
                                if (currentImg && currentImg.src) {
                                    scope.saveImgToClient({ 'imgUrl': currentImg.src });
                                }
                            });
                        });
                    }
                });
                var mathTop = function (img) {
                    img.onload = function () {
                        if (img.height > document.body.clientHeight)
                            img.style.top = 0;
                        else
                            img.style.top = (document.body.clientHeight - img.height) / 2 + "px";
                    }
                }
            },
            restrict: "E",
            replace: true
        }
    })
  	//图书详情页面猜你喜欢
    .directive("bookRelevantDirective", function () {
        return {
            scope: {
                booksProp: "="
            },
            template: '<div class="book-relevant"><div class="relevatn-ttl">猜你喜欢</div><div class="book-list"><table><tr>\
                            <td ng-repeat="book in booksProp" on-finish-render=""><div class="pic"><a ng-click="toPage(book)" href="javascript:;">\
                            <img ng-src="{{book.pic}}"/></a></div><div class="book-ttl">{{book.title}}</div><div class="book-author">{{book.author}}</div></td></tr></table></div></div>',
            controller: ["$scope", "nativeService", "webSiteConstant", function ($scope, nativeService, webSiteConstant) {
                $scope.$on('ngRepeatFinished', function () { });
                $scope.toPage = function (book) {
                    var url = webSiteConstant.htmlHost + "/commodity/booksDetail.html?productId=" + book.id;
                    //window.location.href = url;
                    nativeService.callNativeWebviewWithURL({ url: url, id: -1, title: "" });
                    nativeService.keyboardBarHide();
                };
            }],
            restrict: "E",
            replace: true
        }
    })
    //收藏组件
    .directive("collectionDirective", function () {
        return {
            scope: {
                isCollectionProp: "=",
                isHideTextProp: "@",
                //required:{colType, itemID}
                collectionParamProp: "="
            },
            template: '<span class="switch collection-switch d-flex flex-column" ng-click="collectionClick()">\
                                <input type="checkbox" ng-checked="isCollectionProp" />\
                                <span class="switch-label"></span>\
                                <span>{{isHideTextProp ? \'\' : \'收藏\'}}</sapn>\
                            </span>',
            controller: ["$scope", "$timeout", "commentEndService", "nativeService", function ($scope, $timeout, commentEndService, nativeService) {
                var collectionTimeout;
                $scope.collectionClick = function () {
                    $timeout.cancel(collectionTimeout);
                    collectionTimeout = $timeout(function () {
                        var args = {
                            colType: $scope.collectionParamProp.colType,
                            itemID: $scope.collectionParamProp.itemID,
                            title: $scope.collectionParamProp.title,
                        }
                        if (!$scope.isCollectionProp) {
                            JSON.stringify(args);
                            commentEndService.addcolletion(args).then(function() {
                                $scope.isCollectionProp = true;
                                nativeService.collectionSucceed();
                            });
                        }
                        else {
                            commentEndService.delcolletion(args).then(function() {
                                $scope.isCollectionProp = false;
                                nativeService.cancelCollectionSucceed();
                            })
                        }
                    }, 300);
                }
            }],
            restrict: "E",
            replace: true
        }
    })
     //点赞组件
   .directive("articleLikesDirective", function () {
       return {
           scope: {
               //required:{itemType, itemSn, likeTimes }, not-required: {commentSn,userSn, openID}
               likesParamProp: '=',
               isLikeProp: '='
           },
           template: '<div class="like-box" ng-click="likeClick($event)" ng-class="{checked:isLikeProp}"  ng-bind="likesParamProp.likeTimes+\'人喜欢\'">\
                     ',
           controller: ["$scope", "$timeout", "commentEndService", function ($scope, $timeout, commentEndService) {
               var likeTimeout;
               $scope.likeClick = function (self) {
                   $timeout.cancel(likeTimeout);
                   likeTimeout = $timeout(function () {
                       if (!$scope.isLikeProp) {
                           var args = {
                               itemType: $scope.likesParamProp.itemTypeForLike,
                               itemSn: $scope.likesParamProp.itemSn,
                               commentSn: $scope.likesParamProp.commentSn,
                               userSn: $scope.likesParamProp.userSn,
                               openID: $scope.likesParamProp.openID,
                           }
                           commentEndService.addLike(args).then(function () {
                               $scope.isLikeProp = true;
                               ++$scope.likesParamProp.likeTimes;
                           }, function (err) {
                           });
                       }
                   }, 10);
               }
           }],
           restrict: "E",
           replace: true
       }
   })

    //点赞组件
         .directive("likesDirective", function () {
             return {
                 scope: {
                     //required:{itemType, itemSn, likeTimes }, not-required: {commentSn,userSn, openID}
                     likesParamProp: '=',
                     isLikeProp: '='
                 },
                 template: '<div class="btn-like-comment" ng-class="{active:isLikeProp}" ng-click="likeClick($event)">\
                                <span ng-if="likesParamProp.likeTimes === 0 ? true : false" class="color-1">赞</span>\
                                 <span class="icon"></span>\
                                <span class="num color-1" ng-if="likesParamProp.likeTimes > 0 ? true : false">{{likesParamProp.likeTimes|nullValueShowZeroFilter}} </span>\
                            </div>',
                 controller: ["$scope", "$filter", "$timeout", "commentEndService", function ($scope,$filter, $timeout, commentEndService) {
                     var likeTimeout;
                     $scope.likeClick = function (self) {
                         $timeout.cancel(likeTimeout);
                         likeTimeout = $timeout(function () {
                             if (!$scope.isLikeProp) {
                                 $scope.isLikeProp = true;
                                 ++$scope.likesParamProp.likeTimes;
                                 var args = {
                                     itemType: $scope.likesParamProp.itemTypeForLike,
                                     itemSn: $scope.likesParamProp.itemSn,
                                     commentSn: $scope.likesParamProp.commentSn,
                                     userSn: $scope.likesParamProp.userSn,
                                     openID: $scope.likesParamProp.openID,
                                 }
                                 commentEndService.addLike(args).then(function () {
                                     //前面已经处理
                                 }, function (err) {
                                     if (typeof err == "object") {
                                         if (err.msg) {
                                             //接口返回一个错误
                                         } else {
                                             //网络连接错误                                             
                                         }
                                     }
                                 });
                             }
                         }, 10);
                     }
                 }],
                 restrict: "E",
                 replace: true
             }
         })
    //阅读次数组件
    .directive("readTimesDirective", function () {
        return {
            scope: {
                readTimesProp: "@",
            },
            template: '<div  class ="color-1">\
                            <span>{{readTimesProp}}</span>\
                            <span>浏览</span>\
                        </div>',
            restrict: "E",
            replace: true
        }
        })
        //评论次数组件
        .directive("cmtTimesDirective", function () {
            return {
                scope: {
                    cmtTimesProp: "@",
                },
                template: '<div  class ="color-1">\
                            <span ng-show="cmtTimesProp > 0">{{cmtTimesProp}}</span>\
                            <span ng-show="cmtTimesProp > 0">评论</span>\
                        </div>',
                restrict: "E",
                replace: true
            }
        })
    //广告组件
    .directive("adDirective", function () {
        return {
            scope: true,
            template: '<section class="ad-section content-block web-none">\
                            <a class ="d-flex align-items-center justify-content-center wb-100 external" ng-click="adClick()">\
                                <img class ="ad-item-img responsive-img" ng-src="{{ad.picOne}}" />\
                            </a>\
                        </section>',
            controller: ["$scope", "advertiseEndService", "nativeService", function ($scope, advertiseEndService, nativeService) {
                if (!preprocessing.device.inWeb) {
                    advertiseEndService.articleContent().then(function (data) {
                        $scope.ad = data;
                    });
                }
                $scope.adClick = function () {
                    nativeService.callNativeWebviewWithURLWithNaviBar({ url: $scope.ad.link });
                    nativeService.keyboardBarHide();
                    advertiseEndService.adClick({ adID: $scope.ad.adid }).then(function (data) {
                    });
                };
            }],
            restrict: "E",
            replace: true
        }
    })
	//文章底部图文混排轮显推荐
    .directive("rollArtDirective", function () {
        return {
            scope: {
                artList: '='
            },
            template: '<div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper">\
                            <div class="swiper-slide item first-item" ng-click="adClick()"><table><tr><td class="l"><div class="pic-box"></div></td>\
                            <td class="m"><div class="text-up">来柠檬云记账App，看会计头条</div><div class="text-down">资讯干货一手掌握，会计人的工作宝典！</div></td>\
                            <td class="r"><div class="btn-open-app" ng-click="adClick()"></div></td></tr></table></div>\
                            <div ng-repeat="item in artList" class="swiper-slide item" on-finish-render="" ng-click="view(item)">\
                            <table><tr><td class="l"><div class="pic-box"><img src="{{item.picSrc}}"/></div></td>\
                            <td class="m"><div class="art-title">{{item.title}}</div></td>\
                            <td class="r"><div class="btn-open-app"></div></td></tr></table>\
                            </div></div><div class="swiper-pagination"></div></div></div>',
            controller: ["$scope", "webSiteConstant", function ($scope, webSiteConstant) {
                $scope.$on('ngRepeatFinished', function () {
                    window.setTimeout(function () {
                        var swiper = new Swiper('.swiper-container', {
                            slidesPerView: 1,
                            spaceBetween: 30,
                            loop: true, autoplay: { delay: 2500, disableOnInteraction: false },
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            }
                        });
                    }, 500);
                });
                $scope.adClick = function () { window.location.href = webSiteConstant.appDownload; };
                $scope.view = function (item) {
                    //window.location.href = "newsDetail.html?articleId=" + item.articleID;
                    window.location.href = webSiteConstant.appDownload;
                }
            }],
            restrict: "E",
            replace: true
        }
    })
	//会计头条文章底部图文混排轮显推荐
    .directive("rollArt2Directive", function () {
        return {
            scope: {
                artList: '='
            },
            template: '<div class="swiper-outer"><div class="swiper-container toutiao-swiper-container"><div class="swiper-wrapper">\
                            <div class="swiper-slide item first-item" ng-click="adClick()"><table><tr><td class="l"><div class="pic-box toutiao-pic-box"></div></td>\
                            <td class="m"><div class="text-up">会计人，就看会计头条</div><div class="text-down">资讯干货一手掌握，会计人的工作宝典！</div></td>\
                            <td class="r"><div class="btn-open-app" ng-click="adClick()"></div></td></tr></table></div>\
                            <div ng-repeat="item in artList" class="swiper-slide item" on-finish-render="" ng-click="view(item)">\
                            <table><tr><td class="l"><div class="pic-box"><img src="{{item.picSrc}}"/></div></td>\
                            <td class="m"><div class="art-title">{{item.title}}</div></td>\
                            <td class="r"><div class="btn-open-app"></div></td></tr></table>\
                            </div></div><div class="swiper-pagination"></div></div></div>',
            controller: ["$scope", "webSiteConstant", function ($scope, webSiteConstant) {
                $scope.$on('ngRepeatFinished', function () {
                    window.setTimeout(function () {
                        var swiper = new Swiper('.swiper-container', {
                            slidesPerView: 1,
                            spaceBetween: 30,
                            loop: true, autoplay: { delay: 2500, disableOnInteraction: false },
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            }
                        });
                    }, 500);
                });
                $scope.adClick = function () {
                    window.location.href = window.location.href = webSiteConstant.toutiaoAppDownload;

                };
                $scope.view = function (item) {
                    window.location.href = window.location.href = webSiteConstant.toutiaoAppDownload;
                }
            }],
            restrict: "E",
            replace: true
        }
    })
	//底部广告组件
    .directive("h5Directive", function () {
        return {
            scope: true,
            template: '<div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper">\
                            <div ng-repeat="item in adH5" class="swiper-slide" on-finish-render="">\
                            <a style="background: black;" href="{{item.link}}" class ="d-flex justify-content-center align-items-center flex-1" ng-click="adClick(item)">\
                            <img style="width: 100%;"  ng-src="{{item.picOne}}"></a></div></div><div class="swiper-pagination"></div></div></div>',
            controller: ["$scope", "advertiseEndService", "nativeService", function ($scope, advertiseEndService, nativeService) {
                if (preprocessing.device.inWeb) {
                    advertiseEndService.adH5().then(function(data) {
                        $scope.adH5 = data;
                    });
                }
                $scope.$on('ngRepeatFinished', function () {
                    var swiper = new Swiper('.swiper-container', {
                        spaceBetween: 30, centeredSlides: true,
                        autoplay: { delay: 2500, disableOnInteraction: false },
                        pagination: { el: '.swiper-pagination', clickable: false }
                    });
                });
                $scope.adClick = function (item) {
                    nativeService.callNativeWebviewWithURLWithNaviBar({ url: item.link });
                    nativeService.keyboardBarHide();
                    advertiseEndService.adClick({ adID: item.adid }).then(function (data) { });
                };
            }],
            restrict: "E",
            replace: true
        }
    })
    //推荐组件
    .directive("recommentsDirective", function () {
        return {
            scope: {
                //[{image, name, href, date, times }]
                recommentsProp: '='
            },
            template: '<section class="recomments-section"><div class="area-title">相关推荐</div>\
                            <div class="list-group recomment-list">\
                                <a class ="list-group-item list-item-divider pb-0-6 mb-0 external d-flex content-block" ng-repeat="recomment in recommentsProp" ng-click="recommentClick(recomment);">\
                                 <div  ng-if="recomment.dispType==1001||recomment.dispType==1003" class="d-flex box-item align-items-center" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div class="list-item-text pr-0 flex-1">\
                                       <span class="font-16 article-title-list color-default" ng-cloak>{{recomment.name}}</span>\
                                    <div class="list-item-text-addon d-flex color-1">\
                                        <span class="recomment-date mr-1" ng-cloak>{{recomment.date}}</span>\
                                        <cmt-times-directive cmt-times-prop="{{recomment.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                    </div>\
                                     <img class="list-group-img recomment-img ml-3" ng-src="{{recomment.picOne}}" />\
                                   </div>\
                                  <div ng-if="recomment.dispType==1002" class="pic-box-2 box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                       <span class="font-16 article-title-list color-default" ng-cloak> {{recomment.name}}</span>\
                                    </div>\
                                    <div class="d-flex img-box-three align-items-center">\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picOne}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picTwo}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picThree}}" />\
                                    </div>\
                                    <div class="list-item-text pr-0 mt-1">\
                                        <div class="list-item-text-addon d-flex color-1">\
                                            <span class="recomment-date mr-1" ng-cloak>{{recomment.date}}</span>\
                                            <cmt-times-directive cmt-times-prop="{{recomment.cmtTimes}}"></cmt-times-directive>\
                                        </div>\
                                    </div>\
                                </div>\
                                </a>\
                            </div>\
                        </section>',
            controller: ["$scope", "nativeService", "webSiteConstant", function ($scope, nativeService, webSiteConstant) {
                $scope.recommentClick = function (recomment) {
                    nativeService.callNativeWebviewWithURL({ url: recomment.href, id: recomment.articleID, title: recomment.name });
                    nativeService.keyboardBarHide();
                };
            }],
            restrict: "E",
            replace: true
        }
    })
     //推荐web组件
    .directive("recommentsWebDirective", function () {
        return {
            scope: {
                //[{image, name, href, date, times }]
                recommentsProp: '=',
                isToutiao: '='
            },
            template: '<section class="recomments-section-web">\
                            <div class="d-flex div-divider content-block">\
                            <b></b><span>大家都在看</span><b></b>\
                            </div>\
                            <div class="list-group recomment-list">\
                                <a class ="list-group-item list-item-divider pb-0-6 mb-0 content-block external" ng-repeat="recomment in recommentsProp"  ng-click="recommentClick(recomment, $index);">\
                                   <div ng-if="recomment.dispType==1001||recomment.dispType==1003" class="d-flex box-item align-items-center" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div class="list-item-text pr-0 flex-1">\
                                       <span class="font-16 article-title-list color-default" ng-cloak>{{recomment.name}}</span>\
                                    <div class="list-item-text-addon d-flex color-1">\
                                        <span ng-if="$index < 5" class="view-original-text app-recomment-text mr-1" ng-click="recommentClick(recomment, $index);" ng-cloak>打开APP查看原文</span>\
                                        <span ng-if="$index >= 5" class="view-original-text recomment-date mr-1" ng-click="recommentClick(recomment, $index);" ng-cloak>点击查看原文</span>\
                                        <cmt-times-directive cmt-times-prop="{{recomment.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                    </div>\
                                    <img class="list-group-img recomment-img ml-3" ng-src="{{recomment.picOne}}" />\
                                   </div>\
                                 <div ng-if="recomment.dispType==1002" class="pic-box-2 box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                       <span class="font-16 article-title-list color-default" ng-cloak> {{recomment.name}}</span>\
                                    </div>\
                                    <div class="d-flex img-box-three align-items-center">\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picOne}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picTwo}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{recomment.picThree}}" />\
                                    </div>\
                                    <div class="list-item-text pr-0 mt-1">\
                                        <div class="list-item-text-addon d-flex color-1">\
                                            <span ng-if="$index < 5" class="view-original-text app-recomment-text mr-1" ng-click="recommentClick(recomment, $index);" ng-cloak>打开APP查看原文</span>\
                                            <span ng-if="$index >= 5" class="view-original-text recomment-date mr-1" ng-click="recommentClick(recomment, $index);" ng-cloak>点击查看原文</span>\
                                            <cmt-times-directive cmt-times-prop="{{recomment.cmtTimes}}"></cmt-times-directive>\
                                        </div>\
                                    </div>\
                                </div>\
                              </a>\
                            </div>\
                        </section>',
            controller: ["$scope", "webSiteConstant", function ($scope, webSiteConstant) {
                var downloadUrl = webSiteConstant.appDownload;
                if ($scope.isToutiao) { downloadUrl = webSiteConstant.toutiaoAppDownload1; }
                function getHref(href) {
                    if ($scope.isToutiao) {
                        return href.replace(/newsDetail.html/i, "topNewsDetail.html");
                    } else {
                        return href;
                    }
                }
                $scope.recommentClick = function (item, index) {
                    window.location.href = index < 5 ? downloadUrl : getHref(item.href);
                };
            }],
            restrict: "E",
            replace: true
        }
    })
     //新闻关键字搜索列表组件
    .directive("searchNewsDirective", function () {
        return {
            scope: {
                //[{image, name, href, date, times }]
                searchNewsProp: '=',
                isSearchedProp: '=',
                searchProp: '=',
            },
            template: '<section  ng-class="{true:\'recomments-section\'}[!isSearchedProp]">\
                            <div class="list-group recomment-list">\
                                <a class="list-group-item list-item-divider pb-3 mb-0 external"  ng-repeat="news in searchNewsProp" ng-switch="news.dispType" ng-click="newsClick(news);" ng-class="{true:\'mt-0\'}[$index==0]">\
                                    <div ng-switch-when="1001" class="d-flex box-item align-items-center" ng-class="{true:\'bt-0\'}[$index==0]">\
                                        <div class="list-item-text pr-0 flex-1 wd-4">\
                                            <span class="font-17 article-title-list" ng-cloak ng-bind-html="news.name | keyWordFilter:searchProp"></span>\
                                            <div class="external">\
                                                <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilter:searchProp">\
                                                </p>\
                                             </div>\
                                            <div class="list-item-text-addon d-flex color-1">\
                                                <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                            </div>\
                                        </div>\
                                         <img class="list-group-img recomment-img ml-3" ng-src="{{news.picOne}}" />\
                                    </div>\
                                <div ng-switch-when="1002" class="pic-box-2 box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                        <span class="font-17 article-title-list" ng-cloak ng-bind-html="news.name | keyWordFilter:searchProp"></span>\
                                    </div>\
                                    <div class="d-flex img-box-three align-items-center">\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picOne}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picTwo}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picThree}}" />\
                                    </div>\
                                    <div>\
                                        <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilter:searchProp">\
                                        </p>\
                                    </div>\
                                    <div class="list-item-text pr-0">\
                                        <div class="list-item-text-addon d-flex color-1">\
                                        <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                </div>\
                                </div>\
                                <div ng-switch-when="1003" class="box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                        <span class="font-17 article-title-list ng-cloak ng-bind-html="news.name | keyWordFilter:searchProp"></span>\
                                    </div>\
                                    <div class="img-box-big">\
                                        <img class="list-group-img recomment-img-3" ng-src="{{news.picOne}}" />\
                                    </div>\
                                    <div>\
                                        <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilter:searchProp">\
                                        </p>\
                                    </div>\
                                    <div class="list-item-text pr-0">\
                                       <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                </div>\
                                </div>\
                                </a>\
                                </div>\
                                <div class="hot-text" ng-show="!isSearchedProp">\
                                    未找到相关内容！\
                                </div>\
                        </section>',
            controller: ["$scope", "$filter", "nativeService", function ($scope, $filter, nativeService) {
                $scope.newsClick = function (news) {
                    nativeService.keyboardBarHide();
                    nativeService.callNativeWebviewWithURL({ url: news.href, id: news.articleID, title: news.name });
                }
            }],
            restrict: "E",
            replace: true
        }
        })
        .directive("searchNewsDirectiveRed", function () {
            return {
                scope: {
                    //[{image, name, href, date, times }]
                    searchNewsProp: '=',
                    isSearchedProp: '=',
                    searchProp: '=',
                },
                template: '<section  ng-class="{true:\'recomments-section\'}[!isSearchedProp]">\
                            <div class="list-group recomment-list">\
                                <a class="list-group-item list-item-divider pb-3 mb-0 external"  ng-repeat="news in searchNewsProp" ng-switch="news.dispType" ng-click="newsClick(news);" ng-class="{true:\'mt-0\'}[$index==0]">\
                                    <div ng-switch-when="1001" class="d-flex box-item align-items-center" ng-class="{true:\'bt-0\'}[$index==0]">\
                                        <div class="list-item-text pr-0 flex-1 wd-4">\
                                            <span class="font-17 article-title-list" ng-cloak ng-bind-html="news.name | keyWordFilterRed:searchProp"></span>\
                                            <div class="external">\
                                                <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilterRed:searchProp">\
                                                </p>\
                                             </div>\
                                            <div class="list-item-text-addon d-flex color-1">\
                                                <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                            </div>\
                                        </div>\
                                         <img class="list-group-img recomment-img ml-3" ng-src="{{news.picOne}}" />\
                                    </div>\
                                <div ng-switch-when="1002" class="pic-box-2 box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                        <span class="font-17 article-title-list" ng-cloak ng-bind-html="news.name | keyWordFilterRed:searchProp"></span>\
                                    </div>\
                                    <div class="d-flex img-box-three align-items-center">\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picOne}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picTwo}}" />\
                                        <img class="list-group-img recomment-img" ng-src="{{news.picThree}}" />\
                                    </div>\
                                    <div>\
                                        <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilterRed:searchProp">\
                                        </p>\
                                    </div>\
                                    <div class="list-item-text pr-0">\
                                        <div class="list-item-text-addon d-flex color-1">\
                                        <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                </div>\
                                </div>\
                                <div ng-switch-when="1003" class="box-item" ng-class="{true:\'bt-0\'}[$index==0]">\
                                    <div>\
                                        <span class="font-17 article-title-list" ng-cloak ng-bind-html="news.name | keyWordFilterRed:searchProp"></span>\
                                    </div>\
                                    <div class="img-box-big">\
                                        <img class="list-group-img recomment-img-3" ng-src="{{news.picOne}}" />\
                                    </div>\
                                    <div>\
                                        <p class="list-body-text-1 font-14 article-desc hide-text-one" ng-bind-html="news.desc | keyWordFilterRed:searchProp">\
                                        </p>\
                                    </div>\
                                    <div class="list-item-text pr-0">\
                                        <div class="list-item-text-addon d-flex color-1">\
                                       <cmt-times-directive cmt-times-prop="{{news.cmtTimes}}"></cmt-times-directive>\
                                    </div>\
                                </div>\
                                </div>\
                                </a>\
                                </div>\
                                <div class="hot-text" ng-show="!isSearchedProp">\
                                    未找到相关内容！\
                                </div>\
                        </section>',
                controller: ["$scope", "$filter", "nativeService", function ($scope, $filter, nativeService) {
                    $scope.newsClick = function (news) {
                        nativeService.keyboardBarHide();
                        nativeService.callNativeWebviewWithURL({ url: news.href, id: news.articleID, title: news.name });
                    }
                }],
                restrict: "E",
                replace: true
            }
        })
    .directive("hotNewsDirective", function () {
        return {
            scope: {
                //[{image, name, href, date, times }]
                hotNewsProp: '='
            },
            template: '<section class="hotNews-section">\
                            <div class="hot-text"> 热门阅读</div>\
                            <ul class="list-group">\
                                <li class="list-group-item list-hot-li" ng-repeat="news in hotNewsProp">\
                                    <div class="d-flex flex-1 mr-3">\
                                        <a ng-if="$index<3" class="external flex-1 title-over-width" ng-click="newsClick(news);">\
                                            <span class="hot-index-green">{{$index+1}}.</span>{{news.name}}\
                                        </a>\
                                        <a ng-if="$index>=3" class="external flex-1 title-over-width" ng-click="newsClick(news);">\
                                            <span class="hot-index-gray">{{$index+1}}.</span>{{news.name}}\
                                        </a>\
                                    </div>\
                                </li>\
                            </ul>\
                        </section>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.newsClick = function (news) {
                    nativeService.keyboardBarHide();
                    nativeService.callNativeWebviewWithURL({ url: news.href, id: news.articleID, title: news.name });
                }
            }],
            restrict: "E",
            replace: true
        }
        })
        .directive("hotNewsDirectiveFor", function () {
            return {
                scope: {
                    //[{image, name, href, date, times }]
                    hotNewsProp: '='
                },
                template: '<section class="hotNews-section">\
                            <div class="hot-text"> 热门阅读</div>\
                            <ul class="list-group">\
                                <li class="list-group-item list-hot-li" ng-repeat="news in hotNewsProp">\
                                    <div class="d-flex flex-1 mr-3">\
                                        <a ng-if="$index<3" class="external flex-1 title-over-width" ng-click="newsClick(news);">\
                                            <span class="hot-index-red">{{$index+1}}.</span>{{news.name}}\
                                        </a>\
                                        <a ng-if="$index>=3" class="external flex-1 title-over-width" ng-click="newsClick(news);">\
                                            <span class="hot-index-gray">{{$index+1}}.</span>{{news.name}}\
                                        </a>\
                                    </div>\
                                </li>\
                            </ul>\
                        </section>',
                controller: ["$scope", "nativeService", function ($scope, nativeService) {
                    $scope.newsClick = function (news) {
                        nativeService.keyboardBarHide();
                        nativeService.callNativeWebviewWithURL({ url: news.href, id: news.articleID, title: news.name });
                    }
                }],
                restrict: "E",
                replace: true
            }
        })
    //文章页面热门评论
    .directive("hotCommentsDirective", function () {
        return {
            scope: {
                /*
                 * [{
                 *     isLike, 
                 *     comment:{itemType, itemSn, portrait, nickName, date, likeTimes, userSn, openID, content},
                 *     answer:{itemType, itemSn, portrait, nickName, date, content}
                 * }]
                 */
                commentsProp: "=",
                idProp: "="
            },
            template: '<div class="hot-comments"><div class="area-title"><span>热门评论</span></div>\
                            <div ng-if="commentsProp.length==0" class="no-comments">暂时没有评论！</div>\
                            <ul class="comment-list" ng-click="moreComments()">\
                                <li ng-repeat="item in commentsProp">\
                                    <div class="item-face"><img ng-src="{{item.headImgLink}}"/></div>\
                                    <div class="item-body">\
                                        <div class="head-line"><span class="nick-name">{{item.comment.paUser.nickName}}</span><span class="like-count" ng-if="item.comment.likeCount > 0">{{item.comment.likeCount|nullValueShowZeroFilter}} 赞</span></div>\
                                        <div class="comment-content" ng-bind-html="item.comment.comment"></div>\
                                        <div class="time-line">{{item.comment.createDate | shortDateAndTimeFilter}}</div>\
                                    </div>\
                                </li>\
                            </ul>\
                            <div class="btn-more-comments" ng-click="moreComments()">更多评论</div>\
                        </div>',
            controller: ["$scope", "$filter", "commentEndService", "nativeService", "webSiteConstant", function ($scope,$filter, commentEndService, nativeService, webSiteConstant) {
                $scope.moreComments = function () {
                    var url = webSiteConstant.htmlHost + "/news/comments.html?articleId=" + $scope.idProp;
                    nativeService.keyboardBarHide();
                    nativeService.goToCommentPage({ url: url });
                };
            }],
        }
        })
        //分享热门评论
        .directive("webHotCommentsDirective", function () {
            return {
                scope: {
                    /*
                     * [{
                     *     isLike, 
                     *     comment:{itemType, itemSn, portrait, nickName, date, likeTimes, userSn, openID, content},
                     *     answer:{itemType, itemSn, portrait, nickName, date, content}
                     * }]
                     */
                    commentsProp: "=",
                },
                template: '<div class="hot-comments view-in-app view-in-toutiao"><div class="area-title"><span>热门评论</span></div>\
                            <ul class="comment-list">\
                                <li ng-repeat="item in commentsProp">\
                                    <div class="item-face"><img ng-src="{{item.cmt.portrait}}"/></div>\
                                    <div class="item-body">\
                                        <div class="head-line"><span class="nick-name">{{item.cmt.nickName}}</span>\
                                            <likes-directive likes-param-prop="item.cmt" is-like-prop="item.cmt.isLike"></likes-directive>\
                                        <div class="comment-content" ng-bind-html="item.cmt.content"></div>\
                                        <div class="time-line">{{item.cmt.date | shortDateAndTimeFilter}}</div>\
                                    </div>\
                                </li>\
                            </ul>\
                            <div class="btn-view" ng-click="moreComments()">查看更多精彩评论</div>\
                        </div>',
                controller: ["$scope", "$filter", "commentEndService", "nativeService", "webSiteConstant", function ($scope, $filter, commentEndService, nativeService, webSiteConstant) {
                    var downloadUrl = webSiteConstant.toutiaoAppDownload2;
                    $scope.moreComments = function () {
                        window.location.href = downloadUrl;
                    };
                   
                }],
            }
        })
    //评论组件
    .directive("commentsDirective", function () {
        return {
            scope: {
                /*
                 * [{
                 *     isLike, 
                 *     question:{itemType, itemSn, portrait, nickName, date, likeTimes, userSn, openID, content},
                 *     answer:{itemType, itemSn, portrait, nickName, date, content}
                 * }]
                 */
                commentsProp: "=",
            },
            template: '<section class="comments-section">\
                            <div style="height: 0.75rem;background-color: #F3F5F2;"></div>\
                            <div style="height: 2.625rem;line-height: 2.625rem;padding-left:0.75rem;font-size: 0.8rem;font-weight: 600;">\
                            <span>评论</span></div>\
                            <div class="wb-100"> <hr></div>\
                            <div ng-if="commentsProp.length==0" style="text-align:center;height:2rem;line-height:2rem;">暂时没有评论！</div>\
                             <cmt-directive comments-prop="commentsProp" is-reply-prop="false"></cmt-directive>\
                        </section>',
        }
    })
    //3.1.3  为兼容之前版本 新样式评论组件
    .directive("cmtDirective", function () {
        return {
            scope: {
                /*
                 * [{
                 *     isLike, 
                 *     question:{itemType, itemSn, portrait, nickName, date, likeTimes, userSn, openID, content},
                 *     answer:{itemType, itemSn, portrait, nickName, date, content}
                 * }]
                 */
                commentsProp: "=",
                isReplyProp: "=",
            },
            template: '<ul class="list-group">\
                                <li ng-repeat="comment in commentsProp" class="list-group-item flex-column mt-3 mb-0 font-14">\
                                 <div class="d-flex question wb-100 align-items-flex-start content-block">\
                                 <img class="list-item-img min-2 mr-2 mt-1 comment-img" ng-src="{{comment.cmt.portrait}}" />\
                                    <div class="flex-1">\
                                   <div class="d-flex align-items-center line-height-0 " ng-class="{true:\'color-orange\',false:\'color-1\'}[comment.isAuthorReply]">\
                                 {{comment.cmt.nickName}}\
                            <likes-directive likes-param-prop="comment.cmt" is-like-prop="comment.isLike"></likes-directive>\
                        </div>\
                        <div class="ptb-1 color-default artcie-comment font-16" style="line-height:1.125rem;" ng-click="reply2($event, comment)" ng-bind-html="comment.cmt.content">\
                        </div>\
                        </div>\
                        </div>\
                        <div class="d-flex answer wb-100 align-items-flex-start content-block mt-2" ng-if="comment.reply.content">\
                        <div class="flex-1 color-1 color-comment-bg plr-2 ptb-1 border-radius-1 ml-7">\
                            <span>{{comment.reply.nickName}}</span>\
                            <div class="ptb-1 color-default artcie-comment" style="line-height:1.05rem;" ng-bind-html="comment.reply.content">\
                            </div>\
                        </div>\
                        </div>\
                        <div class="d-flex wb-100 align-items-flex-start content-block mt-2 mb-1">\
                        <div class="font-12 flex-1 color-1 border-radius-1 ml-7 line-height-1rem">\
                                {{comment.cmt.date|shortDateAndTimeFilter}}\
                                <a class="ml-2 color-1" ng-click="delComment(comment,$index);" ng-show="comment.isDel">删除</a>\
                            </div>\
                            <span ng-show="isReplyProp" class="comment-reply color-default font-12" ng-click="reply(comment)">\
                                回复\
                            </span>\
                        </div>\
                        <div class="wb-100 mt-1" ng-if="$index<(commentsProp.length-1)"> <hr></div>\
                        </li>\
                        </ul>',
            controller: ["$scope", "$filter", "commentEndService", "nativeService", function ($scope,$filter, commentEndService, nativeService) {
                $scope.delComment = function (obj, index) {
                    $.confirm('确认删除该评论吗?', function () {
                        var cmt = obj.cmt;
                        commentEndService.delCmt({
                            itemType: cmt.itemType,
                            itemSn: cmt.itemSn,
                            commentSn: cmt.commentSn,
                        }).then(function (data) {
                            $scope.commentsProp.splice(index, 1);
                            nativeService.editNewsCmts({ id: fromId, count: -1 });
                            angular.forEach($scope.commentsProp, function (data, index, array) {
                                if (!data.isReplyDel && data.reply.commentSn == cmt.commentSn) {
                                    data.isReplyDel = true;
                                    data.reply.content = "原评论已删除";
                                }
                            });
                            if (!$scope.isReplyProp) {
                                nativeService.keyboardBarShowUpdateCommentCountDecrement();
                            }
                        });
                    });
                };

                $scope.reply = function (obj) {
                    var parentsn = obj.cmt.commentSn;
                    nativeService.commentBarFocus({ parentsn: parentsn });;
                };
                $scope.reply2 = function (event, obj) {
                    var div = $(event.target);
                    div.addClass("article-comment-active");
                    window.setTimeout(function () { div.removeClass("article-comment-active"); }, 500);
                    $scope.reply(obj);
                }
            }],
        }
    })
    //普通购买组件
    .directive("buyButtonDirective", function () {
        return {
            scope: {
                //{title, imageUrl, price, prodId}
                buyParamProp: '=',
                textProp: '='
            },
            template: '<button class="btn btn-info-yellow wb-45  font-16" ng-click="buyClick()" ng-bind="textProp"></button>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.buyClick = function () {
                    if ($scope.buyParamProp) {
                        if (!$scope.buyParamProp.isSignUp && $scope.buyParamProp.online == 1) {
                            $.toast("商品已下架！")
                            return;
                        }
                        nativeService.purchase($scope.buyParamProp);
                    }
                }
            }],
            replace: true
        };
    })
    //加载更多组件
    .directive("loadMoreDirective", function () {
        return {
            scope: {
                isShowProp: "=",
                titleProp: "@",
            },
            template: '<div ng-show="isShowProp" class="div-loading">\
                         <div class="div-loading-img"><img class="loading-img" src="../src/dist/img/common/Loading.svg"></div> \
                         <div class="div-loading-text">{{titleProp}}</div>\
                    </div>'
            ,
            replace: true,
            restrict: "E",
        };
    })
    .directive("errorDirective", function () {
        return {
            scope: {
                textProp: "@",
            },
            template: ' <section>\
                    <div class="error-box content-detail"></div>\
                    <span class="error-text">{{textProp}}</span>\
                </section>',
            replace: true,
            restrict: "E",
        }
    })
    .directive("copyDirective", function () {
        return {
            scope: {
                textProp: "@",
            },
            template: ' <span class="plr-3 font-11 text-green" style="border-radius: 0.25rem;border: 1px solid #01C257;" ng-click="copyClick()">\
                            复制\
                        </span>',
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.copyClick = function () {
                    nativeService.copy({ string: $scope.textProp });
                }
            }],
            replace: true,
            restrict: "E",
        }
    })
    .directive("qrCodeDirective", function () {
        return {
            scope: true,
            template: ' <div class="qr_code_pc_outer qr_code">\
                        <div class="qr_code_pc_inner" >\
                            <div class="qr_code_pc">\
                                <img class="qr_code_pc_img" src="../src/dist/img/default/qrcode.png">\
                                <p>扫一扫<br>看更多财税干货</p>\
                            </div>\
                        </div>\
                    </div>',
            replace: true,
            restrict: "E",
        }
        })
        .directive("topQrCodeDirective", function () {
            return {
                scope: true,
                template: ' <div class="qr_code_pc_outer qr_code">\
                        <div class="qr_code_pc_inner" >\
                            <div class="qr_code_pc">\
                                <img class="qr_code_pc_img" src="../src/dist/img/default/top-qr-code.png">\
                                <p>扫一扫<br>看更多财税干货</p>\
                            </div>\
                        </div>\
                    </div>',
                replace: true,
                restrict: "E",
            }
        })
    .directive("navigateToWebviewDirective", function () {
        return {
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.navigateTo = function (url) {
                    nativeService.callNativeWebviewWithURLWithNaviBar({ url: url, title: '物流信息' });
                }
            }],
            link: function (s, e, a) {
                e.on("click", function () {
                    var url = a["navigateToWebviewDirective"];
                    if (/^https?:/.test(url)) {
                        s.navigateTo(url);
                    }
                });
            },
            replace: true,
            restrict: "A"
        }
    })
    .directive("navigateToInnerBarWebviewDirective", function () {
        return {
            controller: ["$scope", "nativeService", function ($scope, nativeService) {
                $scope.navigateTo = function (url) {
                    nativeService.navigateToWebView({ url: url });
                }
            }],
            link: function (s, e, a) {
                e.on("click", function () {
                    var url = a["navigateToInnerBarWebviewDirective"];
                    if (/^https?:/.test(url)) {
                        s.navigateTo(url);
                    }
                });
            },
            replace: true,
            restrict: "A"
        }
    })
	//repeat加载结束
    .directive('onFinishRender', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    scope.$emit('ngRepeatFinished'); //事件通知
                }
            }
        }
        })
    .directive('setFocus', function () {
        return function (scope, element) {
            element[0].focus();
        };
    });
})();
/// <reference path="../lib/angular.min.js" />
//后台服务(与服务器端交互)
(function () {
    angular.module("endServicesModule", ["constantsModule"])
    //商品服务
    .service("commodityEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        //get请求(书籍页面改版)，args:{bookId}
        var bookDetails = function (args) {
            return $http({
                url: apiUrlsConstant.commodity.bookDetails,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            });
        };
        //get请求，args: {productId}
        var courseDetail = function (args) {
            return $http({
                url: apiUrlsConstant.commodity.courseDetail,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            });
        };

        var areaData = function areaData() {
            return $http.get(apiUrlsConstant.commodity.areaData);
        };
        //id 获取运费
        var feight = function (args) {
            return $http({
                url: apiUrlsConstant.commodity.feight,
                method: 'GET',
                params: args,
                dataType: 'json'
            });
        }
        angular.extend(this, {
            courseDetail: courseDetail,
            areaData: areaData,
            feight: feight,
            bookDetails: bookDetails
        });
    }])
    //我的订单服务
    .service("myOrderEndService", ["$http", "apiUrlsConstant", "otherUrlsConstant", function ($http, apiUrlsConstant, otherUrlsConstant) {
        //get请求， args: {orderSn, productId}
        var orderDetail = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.orderDetail,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            }, true);
        };
        //get请求， args: {orderSn}
        var spaceOrderDetail = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.spaceOrderDetail,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            }, true);
        };
        //get请求，args: {orderSn, productId}
        var offlineCourseOrderDetail = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.offlineCourseOrderDetail,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            }, true);
        };
        //get请求，args: {orderSn, productId}
        var recordedVideoCourse = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.recordedVideoCourse,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            }, true);
        };
        //post请求，args: {videoType, videoSn}
        var videoPlayed = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.videoPlayed,
                method: 'POST',
                data: args,
                dataType: 'json'
            }, true);
        };
        //post请求，args: {orderSn}
        var verifyExpress = function (args) {
            return $http({
                url: apiUrlsConstant.myOrder.verifyExpress,
                method: 'POST',
                params: args,
                dataType: 'json'
            }, true);
        };
        angular.extend(this, {
            orderDetail: orderDetail,
            spaceOrderDetail: spaceOrderDetail,
            offlineCourseOrderDetail: offlineCourseOrderDetail,
            recordedVideoCourse: recordedVideoCourse,
            videoPlayed: videoPlayed,
            verifyExpress: verifyExpress
        });
    }])
    //资讯服务
    .service("appNewsEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**GET请求，args:{articleID} 请求资讯详情**/
        var newsDetail = function (args) {
            return $http({
                url: apiUrlsConstant.news.detail,
                method: 'GET',
                params: args,
                dataType: 'jsonp'
            });
        };

        var newsCacheDetail = function (args) {
            return $http({
                url: apiUrlsConstant.news.cacheDetail,
                method: 'GET',
                params: args,
                dataType: 'jsonp',
            });
        };

        /**GET请求，args:{articleID,page,count} 请求资讯的相关推荐**/
        var recommend = function (args) {
            return $http({
                url: apiUrlsConstant.news.recommend,
                method: 'GET',
                params: args,
                dataType: 'json'
            });
        };
        /**GET请求，args:{articleId} 分享之后获取推荐列表**/
        var sharedNews = function (args) {
            return $http({
                url: apiUrlsConstant.news.sharedNews,
                method: 'GET',
                params: args,
                dataType: 'jsonp'
            });
        }
        angular.extend(this, {
            newsDetail: newsDetail,
            recommend: recommend,
            newsCacheDetail: newsCacheDetail,
            sharedNews: sharedNews
        });
    }])
    //评论、点赞服务
    .service("commentEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**PUT请求，args:{itemType,itemSn,comment} 留言提交请求**/
        var submitCmt = function (args) {
            return $http({
                url: apiUrlsConstant.comment.comments,
                method: 'PUT',
                data: args,
                dataType: 'json'
            }, true, false);
        };

        /**PUT请求，args:{itemType,itemSn} 留言提交请求**/
        var delCmt = function (args) {
            return $http({
                url: apiUrlsConstant.comment.comments,
                method: 'DELETE',
                params: args,
                dataType: 'json'
            }, true);
        };

        /**POST请求，args(itemType,itemSn,page,count) 留言列表获取请求**/
        var getCmts = function (args) {
            return $http({
                url: apiUrlsConstant.comment.comments,
                method: 'POST',
                data: args,
                dataType: 'json'
            });
        };

        /**POST请求，args(itemType,itemSn,count) 热门留言列表获取请求**/
        var getHotCmts = function (args) {
            return $http({
                url: apiUrlsConstant.comment.hotComments,
                method: 'POST',
                data: args,
                dataType: 'json'
            });
        };

        /**PUT请求,args(ItemType,ItemSn,Count) 留言页面，热门评论请求**/
        var getHotCmtsInCmt = function (args) {
            return $http({
                url: apiUrlsConstant.comment.commentsImCmt,
                method: 'PUT',
                data: args,
                dataType: 'json'
            });
        };

        /**POST请求,args(ItemType,ItemSn,Page,Count,[]CmtSn) 留言页面，最新评论请求**/
        var getRecentCmtsInCmt = function (args) {
            return $http({
                url: apiUrlsConstant.comment.commentsImCmt,
                method: 'POST',
                data: args,
                dataType: 'json'
            });
        };

        /**PUT请求，args:{itemType,itemSn,comment} 留言提交请求**/
        var submitPageCmt = function (args) {
            return $http({
                url: apiUrlsConstant.comment.commentsImCmt+"?type=1",
                method: 'PUT',
                data: args,
                dataType: 'json'
            }, true, false);
        };

        /**POST请求,args(itemType,itemSn,commentSn,userSn,openID) 点赞请求**/
        var addLike = function (args) {
            return $http({
                url: apiUrlsConstant.comment.likes,
                method: 'POST',
                data: args,
                dataType: 'json'
            });
        };
        /**DELETE请求,args(itemType,itemSn,commentSn,userSn,openID) 取消点赞请求**/
        var delLike = function (args) {
            return $http({
                url: apiUrlsConstant.comment.likes,
                method: 'DELETE',
                params: args,
                dataType: 'json'
            }, true);
        };

        /**POST请求,args(colType,itemID) 收藏请求**/
        var addcolletion = function (args) {
            return $http({
                url: apiUrlsConstant.comment.colletion,
                method: 'POST',
                data: args,
                dataType: 'json'
            }, true);
        };
        /**DELETE请求,args(colType,itemID) 取消收藏请求**/
        var delcolletion = function (args) {
            return $http({
                url: apiUrlsConstant.comment.colletion,
                method: 'DELETE',
                params: args,
                dataType: 'json'
            }, true);
        };

        angular.extend(this, {
            submitCmt: submitCmt,
            getCmts: getCmts,
            getHotCmts: getHotCmts,
            getHotCmtsInCmt: getHotCmtsInCmt,
            getRecentCmtsInCmt: getRecentCmtsInCmt,
            submitPageCmt: submitPageCmt,
            delCmt: delCmt,
            addLike: addLike,
            delLike: delLike,
            addcolletion: addcolletion,
            delcolletion: delcolletion
        });
    }])
    /**广告服务**/
    .service("advertiseEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**GET请求,获取文章详情广告请求**/
        var articleContent = function () {
            return $http({
                url: apiUrlsConstant.advertise.articleContent,
                method: 'GET',
                dataType: 'jsonp'
            })
        };
        /**Put请求,args(adID) 广告点击次数+1请求**/
        var adClick = function (args) {
            return $http({
                url: apiUrlsConstant.advertise.adClick,
                method: 'PUT',
                params: args,
                dataType: 'jsonp'
            })
        };
        /**GET请求,获取文章分享到第三方平台，底部横幅请求**/
        var adH5 = function () {
            return $http({
                url: apiUrlsConstant.advertise.adH5,
                method: 'GET',
                dataType: 'jsonp'
            })
        };

        angular.extend(this, {
            articleContent: articleContent,
            adClick: adClick,
            adH5: adH5,
        });

    }])
    .service("newsQueryEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**GET请求，热门搜索 args(count(可选参数))**/
        var hotSearch = function (args) {
            return $http({
                url: apiUrlsConstant.newsQuery.hotSearch,
                method: 'GET',
                params: args,
                data: null,
                dataType: 'json'
            }, false);
        };
        /**GET请求，args(pageIndex, pageSize, searchText)关键字搜索 **/
        var keyWordSearch = function (args) {
            return $http({
                url: apiUrlsConstant.newsQuery.keyWordSearch,
                method: 'POST',
                data: args,
                dataType: 'json'
            }, false);
        };

        angular.extend(this, {
            hotSearch: hotSearch,
            keyWordSearch: keyWordSearch,
        });
    }])
    .service("appLogEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**POST请求，args(itemType,itemSn)分享日志记录接口请求**/
        var submitViewLog = function (args) {
            return $http({
                url: apiUrlsConstant.appLog.viewLog,
                method: 'POST',
                data: args,
                dataType: 'json'
            }, false);
        };

        angular.extend(this, {
            submitViewLog: submitViewLog,
        });

    }])
    .service("rewardEndService", ["$http", "apiUrlsConstant", function ($http, apiUrlsConstant) {
        /**GET请求，args(SignDate)分享日志记录接口请求**/
        var getReadGoldCoin = function (args) {
            return $http({
                url: apiUrlsConstant.reward.readGoldCoin,
                method: 'GET',
                params: args,
                dataType: 'json'
            }, true);
        };

        var getCommentGoldCoin = function (args) {
            return $http({
                url: apiUrlsConstant.reward.commentGoldCoin,
                method: 'GET',
                params: args,
                dataType: 'json'
            }, true);
        };

        var getReadTycPoint = function (args) {
            return $http({
                url: apiUrlsConstant.reward.readTycPoint,
                method: 'POST',
                params: args,
                dataType: 'json'
            }, true);
        };

        angular.extend(this, {
            getReadGoldCoin: getReadGoldCoin,
            getCommentGoldCoin: getCommentGoldCoin,
            getReadTycPoint: getReadTycPoint,
        });
    }])
            /**微信分享请求ticket**/
    .service("getWXTicketService", ["$http", "otherUrlsConstant", "apiUrlsConstant", function ($http, otherUrlsConstant, apiUrlsConstant) {
        var getWXTicket = function (args) {
            return $http.jsonp(
                otherUrlsConstant.getWXTicketUrl + "?callback=JSON_CALLBACK&url=" + args.url
               );
        }
        /**POST请求，args(itemType,itemSn)请求**/
        var submitShareTimes = function (args) {
            return $http({
                url: apiUrlsConstant.news.shareNews,
                method: 'POST',
                params: args,
                dataType: 'json'
            }, false);
        };

        angular.extend(this, {
            getWXTicket: getWXTicket,
            submitShareTimes: submitShareTimes,
        });
    }])
    .service("authService", ["$http", "AuthConstant", function ($http, AuthConstant) {

        var transFn = function (data) {
            return $.param(data);
        };
        /**POST请求，args:{grant_type:password,username:18612693628,
            password:1029571179,client_id:123456,client_secret:abcdef} 登录的请求**/
        var login = function (args) {
            var headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            };
            return $http.post(AuthConstant.auth.login, transFn(args), { headers: headers });
        };
        //获取验证码 POST 请求 args:{Mobile,ClientId}
        var verifyCode = function (args, token) {
            var headers = {
                'Authorization': String.prototype.concat('bearer ', token)
            };
            return $http.post(AuthConstant.auth.register, args, { headers: headers, dataType: 'json' });
        }

        //根据验证码注册 PUT 请求 args:{Mobile,VerifyCode,ClientId,TimeStamp,Stamp}
        var register = function (args, token) {
            var headers = {
                'Authorization': String.prototype.concat('bearer ', token)
            };
            return $http.put(AuthConstant.auth.register, args, { headers: headers, dataType: 'json' });
        }

        //发送验证码  POST 请求 args{Phone}
        var sendCode = function (args) {
            var headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            };
            return $http.post(AuthConstant.auth.sendCode, transFn(args), { headers: headers, });
        }
        //确认验证码 string mobile, string confirmCode
        var confimCode = function (args) {
            return $http.post(AuthConstant.auth.confimCode, args);
        }
        //修改密码 args: { tel: tel, code: msg, pwd: pwd },
        var changePaw = function (args) {
            var headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            };
            return $http.post(AuthConstant.auth.changePaw, transFn(args), { headers: headers, });
        }

        angular.extend(this, {
            login: login,
            verifyCode: verifyCode,
            register: register,
            sendCode: sendCode,
            confimCode: confimCode,
            changePaw: changePaw,
        })

    }])
})();
/// <reference path="../lib/angular.min.js" />
//过滤器(对原始数据进行转换操作)
(function () {
    angular.module("filtersModule", ["constantsModule"])
        .filter("addCheckStateToObject", [function () {
            return function (data, def) {
                if (angular.isObject(data)) {
                    data.checkState = def || false;
                }
                return data;
            };
        }])
        //为集合对象中每个对象添加选中状态属性
        .filter("addCheckStateToEachObject", ["$filter", function ($filter) {
            return function (data, def) {
                if (angular.isArray(data)) {
                    angular.forEach(data, function (e) {
                        $filter("addCheckStateToObject")(e, def);
                    });
                }
                return data;
            }
        }])
        .filter("firstNotNullFilter", [function () {
            return function (data) {
                for (var i in data) {
                    if (!angular.isUndefined(data[i])) {
                        return data[i];
                    }
                }
                return undefined;
            }
        }])
    //日期格式转换
    .filter("dateTimeFormatFilter", ["regExpressionsConstant", function (regExpressionsConstant) {
        return function (data, format) {
            if (angular.isString(data) && angular.isString(format)) {
                var match = data.match(regExpressionsConstant.date);
                if (match) {
                    var date = { year: match[1] || 1, month: match[2] || 1, day: match[3] || 1, hour: match[4] || 0, minute: match[5] || 0, second: match[6] || 0 };
                    return format.replace(/yyyy/g, date.year)
                                 .replace(/MM/g, date.month)
                                 .replace(/dd/g, date.day)
                                 .replace(/DD/g, date.day)
                                 .replace(/HH/g, date.hour)
                                 .replace(/hh/g, date.hour)
                                 .replace(/mm/g, date.minute)
                                 .replace(/ss/g, date.second)
                                 .replace(/desc/ig, function () {
                                     var deltaSeconds = new Date().getTime() / 1000 - new Date(date.year, date.month - 1, date.day, date.hour, date.minute, date.second).getTime() / 1000;
                                     if (deltaSeconds >= 0) {
                                         if (deltaSeconds < 60) {
                                             return '刚刚';
                                         }
                                         else if (deltaSeconds >= 60 && deltaSeconds < 60 * 60) {
                                             return String.prototype.concat(parseInt(deltaSeconds / 60), '分钟前');
                                         }
                                         else if (deltaSeconds >= 60 * 60 && deltaSeconds < 24 * 60 * 60) {
                                             return String.prototype.concat(parseInt(deltaSeconds / 60 / 60), '小时前');
                                         }
                                         return String.prototype.concat(date.year, "-", date.month, "-", date.day);
                                     }
                                     else {
                                         return String.prototype.concat(date.year, "-", date.month, "-", date.day);
                                     }
                                 });
                }
            }
            return data;
        }
    }])
    //日期描述
    .filter("dateDescFilter", ["$filter", function ($filter) {
        return function (data) {
            return $filter("dateTimeFormatFilter")(data, "desc");
        }
    }])
    //短日期类型
    .filter("shortDateFilter", ["$filter", function ($filter) {
        return function (data) {
            return $filter("dateTimeFormatFilter")(data, "MM-dd");
        }
    }])
    //短日期类型
    .filter("shortDateAndTimeFilter", ["$filter", function ($filter) {
        return function (data) {
            return $filter("dateTimeFormatFilter")(data, "MM-dd hh:mm");
        }
    }])

    //长日期类型
    .filter("longDateFilter", ["$filter", function ($filter) {
        return function (data) {
            return $filter("dateTimeFormatFilter")(data, "yyyy-MM-dd");
        }
    }])
    //时间段显示 月-日 20:00-21:00
    .filter("dateRangeFilter", ["$filter", function ($filter) {
        return function (start, end) {
            var value = $filter("dateTimeFormatFilter")(start, "MM月dd日 hh:mm");
            if (end) {
                value += "-" + $filter("dateTimeFormatFilter")(end, "hh:mm");
            }
            return value;
        }
    }])
    ////短日期类型 
    .filter("shortDateFilterFromUnixFilter", ["$filter", "regExpressionsConstant", function ($filter, regExpressionsConstant) {
        return function (data) {
            var unixtime = 1358932051;
            if (angular.isString(data)) {
                if (!regExpressionsConstant.date.test(data)) {
                    var unixtime = data
                    var unixTimestamp = new Date(unixtime * 1)
                    var M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1))
                    var D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate())
                    var toDay = M + '-' + D
                    return $filter("dateDescFilter")(toDay);
                }
                return data;
            }
            return data;
        }
    }])
    .filter("keyWordFilter", ["$sce", function ($sce) {
        return function (input, words) {
            if (!words)
                return input;
            var result = input.replace(/<[^>]+>/g, "").replace(words, "<button disabled='disabled'   style='color:rgba(1,194,87,1);background-color: transparent;border:0;padding :0 '>" + words + "</button>");
            return $sce.trustAsHtml(result);
        }
        }])
        .filter("keyWordFilterRed", ["$sce", function ($sce) {
            return function (input, words) {
                if (!words)
                    return input;
                var result = input.replace(/<[^>]+>/g, "").replace(words, "<button disabled='disabled'   style='color:rgba(255,0,0,1);background-color: transparent;border:0;padding :0 '>" + words + "</button>");
                return $sce.trustAsHtml(result);
            }
        }])
    //数据为空时显示0
    .filter("nullValueShowZeroFilter", [function () {
        return function (value) {
            if (!value) {
                return 0;
            }
            return value;
        }
    }])
    //资讯类转换成文章模板类
    .filter("appNewsToArticleFilter", ["$filter", function ($filter) {
        return function (data) {
            if (data && angular.isObject(data)) {
                var article = {};
                article["itemType"] = 1060;
                article["itemTypeForLike"] = 1060;
                article["itemSn"] = data["news"]["articleID"];
                article["commentSn"] = 0;
                article["userSn"] = 0;
                article["openID"] = 0;
                article["name"] = data["news"]["title"];
                article["author"] = data["news"]["author"];
                article["source"] = data["news"]["source"];
                article["date"] = $filter("dateDescFilter")(data["news"]["editDate"]);
                article["body"] = data["body"];
                article["readTimes"] = (data["news"]["startReadTimes"] || 0) + (data["news"]["realReadTimes"] || 0);
                article["likeTimes"] = (data["news"]["startLikeTimes"] || 0) + (data["news"]["realLikeTimes"] || 0);
                article["authorOrCode"] = data["authorOrCode"];
                return article;
            }
            return data;
        }
    }])
    //资讯类动态数据转换成文章动态模板
    .filter("appNewsDynamicToArticleFilter", ["$filter", function ($filter) {
        return function (data) {
            if (data && angular.isObject(data)) {
                var article = {};
                article["itemType"] = 1060;
                article["itemTypeForLike"] = 1060;
                article["itemSn"] = data["articleID"];
                article["commentSn"] = 0;
                article["userSn"] = 0;
                article["openID"] = 0;
                article["readTimes"] = (data["startReadTimes"] || 0) + (data["realReadTimes"] || 0);
                article["likeTimes"] = (data["startLikeTimes"] || 0) + (data["realLikeTimes"] || 0);
                return article;
            }
            return data;
        }
    }])
     //资讯类转换成分享模板类
    .filter("appNewsToShareFilter", [function () {
        return function (data) {
            if (data && angular.isObject(data)) {
                return {
                    title: data.title,
                    descr: data.summary,
                    url: location.href,
                    thumbURL: data.picShare || data.picOne || data.picTwo || data.picThree,
                }
            }
            return data;
        }
    }])
 //资讯类转换成收藏模板类
    .filter("appNewsToCollectionFilter", [function () {
        return function (data) {
            if (data && angular.isObject(data)) {
                return {
                    colType: 1001,
                    itemID: data.articleID,
                    title: data.title,
                }
            }
            return data;
        }
    }])
            .filter("ftToCollectionFilter", [function () {
                return function (data) {
                    if (data && angular.isObject(data)) {
                        return {
                            colType: 1003,
                            itemID: data.itemID
                        }
                    }
                    return data;
                }
            }])
  //将资讯集合转换为推荐模板类
    .filter("appNewsToRecommentsFilter", ["$filter", "webSiteConstant", function ($filter, webSiteConstant) {
        return function (data) {
            if (angular.isArray(data) && data.length > 0) {
                var recomments = [];
                angular.forEach(data, function (e) {
                    recomments.push({
                        articleID: e.articleID,
                        name: e.title,
                        href: webSiteConstant.htmlHost + "/news/newsDetail.html?articleId=".concat(e.articleID),
                        //date: $filter("dateDescFilter")(e["editDate"]),
                        date: "",
                        image: e.picOne || e.picTwo || e.picThree,
                        picOne: e.picOne,
                        picTwo: e.picTwo,
                        picThree: e.picThree,
                        dispType: e.dispType,
                        times: (e.startReadTimes || 0) + (e.realReadTimes || 0),
                        cmtTimes: e.commentTimes || 0
                    });
                });
                return recomments;
            }
            return data;
        }
    }])
//将关键字检索资讯集合转换为search模板类
    .filter("appNewsToSearchFilter", ["$filter", "webSiteConstant", function ($filter, webSiteConstant) {
        return function (data) {
            if (angular.isArray(data) && data.length > 0) {
                var recomments = [];
                angular.forEach(data, function (e) {
                    recomments.push({
                        articleID: e.infoId,
                        name: e.title,
                        href: webSiteConstant.htmlHost + "/news/newsDetail.html?articleId=".concat(e.infoId),
                        image: e.pics.length > 0 ? e.pics[0]:"",
                        picOne: e.pics.length > 0 ? e.pics[0] : "",
                        picTwo: e.pics.length > 1 ? e.pics[1] : "",
                        picThree: e.pics.length > 2 ? e.pics[2] : "",
                        dispType: e.pics.length > 2 ? 1002 :( e.pics.length>0  ? 1001 : 1004),
                        desc: e.content,
                        cmtTimes: e.cmtTimes||0
                    });
                });
                return recomments;
            }
            return data;
        }
    }])
  //将资讯留言集合转换为留言模板类
    .filter("appNewsCmtsToCommentsFilter", ["$filter", function ($filter) {
        return function (data) {
            if (angular.isArray(data) && data.length > 0) {
                var comments = [];
                angular.forEach(data, function (e) {
                    comments.push($filter("toCommentFilter")(e));
                });

                return comments;
            }
            return data;
        }
    }])
    .filter("toCommentFilter", [function () {
        return function (data) {
            if (angular.isObject(data)) {
                var comment = {
                    isLike: data.isLike,
                    isDel: data.isDel,
                    question: {
                        itemType: data.comment.itemType,
                        itemTypeForLike: data.comment.itemType + 1,
                        itemSn: data.comment.itemSn,
                        commentSn: data.comment.commentSn,
                        portrait: data.headPortrait,
                        nickName: data.nickName,
                        date: data.comment.createDate,
                        likeTimes: data.comment.likeCount,
                        userSn: data.comment.userSn,
                        openID: data.comment.openID,
                        content: data.comment.comment
                    },
                    answer: {
                        itemType: data.comment.itemType,
                        itemTypeForLike: data.comment.itemType + 1,
                        itemSn: data.comment.itemSn,
                        portrait: '../src/dist/img/default/i-head.png',
                        nickName: '柠檬君回复',
                        date: data.comment.feedBackDate,
                        content: data.comment.feedBack
                    }
                }
                return comment;
            }
            return data;
        }
    }])
     //将带回复的留言集合转换为留言模板类
    .filter("hasReplyCmtsToCommentsFilter", ["$filter", function ($filter) {
        return function (data) {
            if (angular.isArray(data) && data.length > 0) {
                var comments = [];
                angular.forEach(data, function (e) {
                    comments.push($filter("toCmtFilter")(e));
                });

                return comments;
            }
            return data;
        }
    }])
    .filter("toCmtFilter", [function () {
        return function (data) {
            if (angular.isObject(data)) {
                var cmt = data.comment;
                var rep = data.reply;
                var isHasReply = rep.comment != null;
                var comment = {
                    isLike: data.isLike,
                    isDel: data.isDel,
                    isAuthorReply: data.isAuthorReply,
                    isReplyDel: data.isReplyDel,
                    isHasReply: isHasReply,
                    cmt: {
                        itemType: cmt.comment.itemType,
                        itemTypeForLike: cmt.comment.itemType + 1,
                        itemSn: cmt.comment.itemSn,
                        commentSn: cmt.comment.commentSn,
                        portrait: cmt.headImgLink,
                        nickName: cmt.comment.paUser.nickName,
                        date: cmt.comment.createDate,
                        likeTimes: cmt.comment.likeCount || 0,
                        userSn: cmt.comment.userSn,
                        openID: cmt.comment.openID,
                        content: cmt.comment.comment
                    },
                    reply: {
                        itemTypeForLike: cmt.comment.itemType + 1,
                        itemSn: cmt.comment.itemSn,
                        commentSn: isHasReply ? rep.comment.commentSn : 0,
                        portrait: isHasReply ? rep.headImgLink : "",
                        nickName: isHasReply ? rep.comment.paUser.nickName : "",
                        date: isHasReply ? rep.comment.createDate : "",
                        likeTimes: isHasReply ? rep.comment.likeCount || 0 : 0,
                        userSn: isHasReply ? rep.comment.userSn : 0,
                        openID: isHasReply ? rep.comment.openID : 0,
                        content: isHasReply ? (data.isReplyDel ? "原评论已删除" : rep.comment.comment) : ""
                    }
                }
                return comment;
            }
            return data;
        }
    }])
        //商品类转换成文章模板类
    .filter("productToArticleFilter", ["$filter", function ($filter) {
        return function (data) {
            if (data && angular.isObject(data)) {
                var article = {};
                article["itemTypeForLike"] = 1040;
                article["itemSn"] = data["prodId"];
                article["name"] = data["prodName"];
                article["date"] = $filter("dateDescFilter")(data["createdDate"]);
                //article["image"] = data["bigPic"];
                //article["body"] = data["prodDesc"];
                article["readTimes"] = (data["readTimes1"] || 0) + (data["readTimes2"] || 0);
                article["likeTimes"] = (data["likeTimes1"] || 0) + (data["likeTimes2"] || 0);
                return article;
            }
            return data;
        }
    }])
    //商品类转换成分享模板类
    .filter("productToShareFilter", ["webSiteConstant", function (webSiteConstant) {
        return function (data) {
            if (data && angular.isObject(data)) {
                var url = data.prodType == 2020 ? location.href : webSiteConstant.kjxyHost + "/home/courseInfo?productId=" + data.ProdId;
                return {
                    title: data.prodName,
                    descr: data.prodSummary,
                    url: url,
                    thumbURL: data.pic1 || data.bigPic,
                }
            }
            return data;
        }
    }])
    //课程类转换成分享模板类
    .filter("courseToShareFilter", ["webSiteConstant", function (webSiteConstant) {
        return function (data) {
            if (data && angular.isObject(data)) {
                return {
                    title: data.title,
                    descr: data.summary,
                    url: webSiteConstant.kjxyHost + "/course/detail?courseId=" + data.productId,
                    thumbURL: data.smallPic,
                }
            }
            return data;
        }
    }])
    //书籍类转换成分享模板类
    .filter("bookToShareFilter", ["webSiteConstant", function (webSiteConstant) {
        return function (data) {
            if (data && angular.isObject(data)) {
                return {
                    title: data.title,
                    descr: data.summary.replace(/<[^>]+>/g, ""),
                    url: webSiteConstant.htmlHost + "/commodity/booksDetail.html?productId=" + data.id,
                    thumbURL: data.pic
                }
            }
            return data;
        }
    }])
    //商品类转换成收藏模板类
    .filter("productToCollectionFilter", [function () {
        return function (data, colType) {
            if (data && angular.isObject(data)) {
                return {
                    colType: colType ? colType : 1002,
                    itemID: data.prodId,
                    title: data.prodName,

                }
            }
            return data;
        }
    }])
    //课程类转换成收藏模板类
    .filter("courseToCollectionFilter", [function () {
        return function (data, colType) {
            if (data && angular.isObject(data)) {
                return {
                    colType: colType ? colType : 1002,
                    itemID: data.productId,
                    title: data.title,
                }
            }
            return data;
        }
    }])
    //书籍类转换成收藏模板类
    .filter("bookToCollectionFilter", [function () {
        return function (data, colType) {
            if (data && angular.isObject(data)) {
                return {
                    colType: colType ? colType : 1002,
                    itemID: data.id,
                    title: data.title,

                }
            }
            return data;
        }
    }])
    //NULL转空字符串
    .filter("nullToEmptyString", [function () {
        return function (data) {
            if (data == null || data == "null") return "";
            return data;
        }
    }])
    //将商品集合转换为推荐模板类
    .filter("productsToRecommentsFilter", ["$filter", function ($filter) {
        return function (data, type) {
            if (angular.isArray(data) && data.length > 0) {
                var recomments = [];
                angular.forEach(data, function (e) {
                    recomments.push({
                        name: e.prodName,
                        href: !type ? "./booksDetail.html?productId=".concat(e.prodId) : "./courseDetail.html?productId=".concat(e.prodId),
                        date: $filter("dateDescFilter")(e["createdDate"]),
                        image: e.smallPic || e.pic1 || e.bigPic,
                        times: (e.readTimes1 || 0) + (e.readTimes2 || 0)
                    });
                });
                return recomments;
            }
            return data;
        }
    }])
    //將商品类转换为购买模板类
    .filter("productToBuyFilter", [function () {
        return function (data) {
            if (angular.isObject(data)) {
                var isNeedAddress = (data.expressNeeded == null || data.expressNeeded == undefined) ? "" : data.expressNeeded.toString();
                return {
                    title: data.prodName,
                    imageUrl: data.smallPic || data.pic1 || data.bigPic,
                    originalPrice: data.originalPrice.toString(),
                    price: data.price.toString(),
                    prodId: data.prodId.toString(),
                    isNeedAddress: isNeedAddress,
                    online: data.hide == null ? 0 : data.hide,//0 显示 ，1 隐藏
                    prodType: data.prodType, //商品类别 2010：App课程类 2020：App书籍类
                    prodKind: data.prodKind, //课程类别 1010表示录播课程，1020老师安排,1030直播课
                    liveTool: data.Num4,//直播工具 1010 微吼直播，1020 展示互动
                };
            }
            return data;
        }
    }])
    //將课程类转换为购买模板类
    .filter("courseToBuyFilter", [function () {
        return function (data) {
            if (angular.isObject(data)) {
                var isNeedAddress = (data.needExpress == null || data.needExpress == undefined) ? "" : data.needExpress.toString();
                return {
                    title: data.title,
                    imageUrl: data.smallPic,
                    originalPrice: data.price.toString(),
                    price: data.price.toString(),
                    prodId: data.productId.toString(),
                    isNeedAddress: isNeedAddress,
                    online: data.hide,//0 显示 ，1 隐藏
                    prodType: 2010, //商品类别 2010：App课程类 2020：App书籍类
                    prodKind: data.kind, //课程类别 1010表示录播课程，1020老师安排,1030直播课
                    liveTool: data.liveTool,//直播工具 1010 微吼直播，1020 展示互动
                    isInvoice: data.isInvoice,//true 需要，false 不需要
                    isSignUp: data.isSignUp,//是否报名
                };
            }
            return data;
        }
    }])
    //將书籍类转换为购买模板类
    .filter("bookToBuyFilter", [function () {
        return function (data) {
            if (angular.isObject(data)) {
                return {
                    title: data.title,
                    imageUrl: data.pic,
                    originalPrice: data.price.toString(),
                    price: data.price.toString(),
                    prodId: data.id.toString(),
                    isNeedAddress: 2,
                    online: data.isOnline,
                    prodType: 2020, //商品类别 2010：App课程类 2020：App书籍类
                    prodKind: 0, //课程类别 1010表示录播课程，1020老师安排
                    isInvoice: data.isInvoice,//true 需要，false 不需要
                };
            }
            return data;
        }
    }])
    //内容以html格式展示
    .filter("htmlContent", function ($sce) {
        return function (input) {
            return $sce.trustAsHtml(input);
        }
    });
})();
/// <reference path="../lib/angular.min.js" />
//不是与后台交互逻辑的方法
(function () {
    angular.module("frontServicesModule", [])
    //转换服务
    .service("convertFrontService", [function () {
        //将对象转化为查询字符串格式
        //obj: 转化的对象
        //pre: 查询字符串前要插入的字符串(比如?,&)
        var convertToQueryString = function (obj, pre) {
            var keyvalues = [],
                prefix = pre || "";
            if (obj) {
                for (var key in obj) {
                    if (typeof (obj[key]) !== "function") {
                        keyvalues.push(key + "=" + encodeURIComponent(obj[key]));
                    }
                }
            }
            return prefix + keyvalues.join("&");
        };
        angular.extend(this, {
            convertToQueryString: convertToQueryString
        })
    }])
    //location服务
    .service("locationFrontService", [function () {
        //从url中读取查询字符串
        var queryString = function (key) {
            var ret = null;
            if (location.search && !/^\s*$/.test(key)) {
                var reg = new RegExp(key + "=(.*?)(&|$)", "i");
                var match = location.search.match(reg);
                if (match) {
                    ret = decodeURIComponent(match[1]);
                }
            }
            return ret;
        };
        angular.extend(this, {
            queryString: queryString
        });
    }])
    //弹框
    .service("alertFrontService", [function () {
        angular.extend(this, {
            alert: function (obj) {
                var msg = "";
                if (typeof (obj) == 'object') {
                    for (var name in obj) {
                        msg += name.concat(' - ', obj[name]) + "\n";
                    }
                }
                else {
                    msg = obj;
                }
                alert(msg);
            }
        });
    }])
})();
/// <reference path="../lib/angular.min.js" />
/// <reference path="../preprocessing.js" />

//原生(ios|android)服务(与原生交互)
(function (win) {
    angular.module("nativeServicesModule", [])
    .service("nativeService", ["$q", function ($q) {
        var LmOb = function () {
            var self = this;
            self.obserers = [];
            self.notify = function (type, params) {
                for (var item in self.obserers) {
                    self.obserers[item](type, params);
                }
            },
            self.addOb = function (func) {
                self.obserers.push(func);
            }
        }
        var obsersss = new LmOb();
        //评论条评论发布
        var keyboardBarCommentReturn = function (params) {
            obsersss.notify(0, arguments);
        }
        //文章评论条 评论点击
        var keyboardBarRecordReturn = function (params) {
            obsersss.notify(1, params);
        }
        var keyboardBarShareReturn = function (params) {
            obsersss.notify(3, params);
        }

        var lemonAppUserPresenceState = function (params) {
            obsersss.notify(4, params);
        }

        var keyboardCustomerServices = function (params) {
            obsersss.notify(5, params);
        }
        //登录成功调用
        var loginSucess = function () {
            obsersss.notify(6, "");
        };

        ///是否跳转下一篇文章 下拉：0 不返回 1返回；上拉：0 不跳转，1跳转
        var jumpNews = function () {
            obsersss.notify(7, arguments);
        };

        var goHtmlTop = function () {
            $(".content").scrollTop('0px');
        }

        angular.extend(win, { obsersss, keyboardBarCommentReturn, keyboardBarRecordReturn, keyboardBarShareReturn, lemonAppUserPresenceState, keyboardCustomerServices, loginSucess, goHtmlTop, jumpNews})
        //原生方法名称
        const nativeFunctionsEnum = {
            //返回
            back: 'callNativeHomePageBack',
            //登录
            login: 'callNativeWebLoginView',
            //登录状态
            loginState: 'callNativeLoginState',
            //收藏成功
            collectionSucceed: 'collectionSucceed',
            //取消收藏成功
            cancelCollectionSucceed: 'cancelCollectionSucceed',
            //复制
            copy: 'callNativeSetPasteboardValue',
            //单一分享
            share: 'callNativeWebShare',
            //调用原生分享菜单，分享
            shareMenu: 'callNativeWebPageShare',
            //token
            token: 'getNativeAccessToken',
            //普通购买
            purchase: 'callNativeProduct',
            //打开客服QQ
            qqService: 'callNativeOnlineService',
            //在原生APP中新建一个webview
            navigateToWebView: 'callNativeWebviewWithURL',
            //文章是否收藏
            articleBarInitData: 'keyboardBarShowInitData',
            //评论条显示
            keyboardBarShow: 'keyboardBarShow',
            //评论条消失
            keyboardBarHide: 'keyboardBarHide',
            //新闻webView
            callNativeWebviewWithURL: 'callNativeWebviewWithURL',
            //广告webView
            callNativeWebviewWithURLWithNaviBar: 'callNativeWebviewWithURLWithNaviBar',
            //评论数减1
            keyboardBarShowUpdateCommentCountDecrement: 'keyboardBarShowUpdateCommentCountDecrement',
            //附件展示
            callNativeAttachmentShow: 'callNativeAttachmentShow',
            //导航条的隐藏或修改
            callNativeNaviBarState: 'callNativeNaviBarState',
            //图片预览时隐藏显示原生头尾
            changeBarViewsState: 'changeBarViewsState',
            //获取原生生成的APP唯一标识UUID
            getAppUniqueUUID: 'getAppUniqueUUID',
            //图片浏览时保存图片到手机
            saveImgToClient: 'saveImgToClient',
            //获取文章详情
            getNewsDetailInfo: 'getNewsDetailInfo',
            //调用原生图片浏览
            showMagnifiedPic: 'showMagnifiedPic',
            //调用原生发票扫描页
            showScanCode: 'showScanCode',
            //h5页面滑动到顶部
            slideToTop: 'slideToTop',
            //h5页面滑动到底部
            slideToBot: 'slideToBot',
            //显示奖励 type Amount(目前只是文章详情用到)[1050,1060]
            showReward: 'showReward',
            //留言页面 评论获取焦点
            commentBarFocus: 'commentBarFocus',
            //跳转到留言页面 评论条显示
            goToCommentPage: 'goToCommentPage',
            //跳转到课程列表
            goToCouseListPage: 'goToCouseListPage',
            //更新文章评论数
            editNewsCmts: 'editNewsCmts',
            //键盘弹出
            keyboardShow:'keyboardShow',
        };

        //本方法兼容安卓与iOS
        function callMobile() {

            if (typeof (preprocessing) == "undefined") {
                var device = {};
                if (/(lemonapp|AccTouTiao)/.test(navigator.userAgent)) {
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                        Object.defineProperty(device, "ios", {
                            get: function () {
                                return true;
                            }
                        });
                    }
                    else if (/Android/i.test(navigator.userAgent)) {
                        Object.defineProperty(device, "android", {
                            get: function () {
                                return true;
                            }
                        });
                    }
                    Object.defineProperty(device, "inApp", {
                        get: function () {
                            return !!(device.ios || device.android);
                        }
                    });
                    var reg = /lemonapp\/([\w\W]*?)\//;
                    var version;
                    if (navigator.userAgent.match(reg)) {
                        version = navigator.userAgent.match(reg)[1];
                    }
                    Object.defineProperty(device, "version", {
                        get: function get() {
                            return version;
                        }
                    });
                    Object.defineProperty(device, "compareVersion", {
                        get: function get(version1, version2) {
                            if (!version2) {
                                version2 = device.version;
                            }
                            if (!version2) {
                                return false;
                            }
                            var v1 = parseInt(version1.replace(/\./g, ""));
                            var v2 = parseInt(version2.replace(/\./g, ""));
                            return v2 >= v1;
                        }
                    });
                }
                else {
                    Object.defineProperty(device, "inWeb", {
                        get: function () {
                            return true;
                        }
                    });
                }
                Object.assign(window.preprocessing = window.preprocessing || {}, {
                    device: device,
                });
            }

            if ((preprocessing.device.ios)) {
                callMobile = function (hm, p) {
                    var handlerInterface = 'Native';
                    //handlerInterface由iOS addScriptMessageHandler
                    var dic = { 'handlerInterface': handlerInterface, 'function': hm, 'parameters': p };
                    win.webkit.messageHandlers[handlerInterface].postMessage(dic);
                };
            }
            else if (preprocessing.device.android) {
                callMobile = function (hm, p) {
                    window.android.postToNativeMessage(hm, (p || (p = {})) && JSON.stringify(p));
                }
            }
                //当引用的外部脚本(preprocessing)不存在时，使用默认函数
            else {
                callMobile = function (hm, p) {
                    var handlerInterface = 'Native';
                    //handlerInterface由iOS addScriptMessageHandler
                    var dic = { 'handlerInterface': handlerInterface, 'function': hm, 'parameters': p };
                    win.webkit.messageHandlers[handlerInterface].postMessage(dic);
                };
            }
        }

        //执行一次替换原始callMobile
        callMobile();

        //回调函数任务{callbackid: promise}, callbackid: 随机唯一标识数， promise: 承诺

        const tasks = {};

        //原生方法回调函数
        //callbackid: number, status: boolean, args: 数据类型
        win.callbackFromNative = function (callbackid, status, args) {
            var task = tasks[callbackid];
            if (task) {
                if (status == "1") {
                    task.resolve(args);
                }
                else {
                    task.reject(args);
                }
                return delete tasks[callbackid];
            }
            throw new Error("native call err");
        }

        //调用原生接口及调用原生接口后回调的函数
        //key: 'nativeFunctionsEnum'(原生方法名称),
        //parameters: object(原生方法使用的参数)
        //needCallback: boolean(是否需要回调)
        function nativeTask(key, parameters, needCallback) {
            var deferred = $q.defer(),
                exist = false;
            for (var name in nativeFunctionsEnum) {
                if (nativeFunctionsEnum[name] === key) {
                    //如果需要回调那么将回调任务添加到回调任务列表中
                    if (needCallback == true) {
                        parameters = parameters || {};
                        parameters.callbackId = Math.floor(Math.random() * 2000000000);
                        tasks[parameters.callbackId] = deferred;
                    }
                    exist = true;
                    try {
                        callMobile(key, parameters);
                    } catch (e) {
                        if (parameters && parameters.callbackId) {
                            delete tasks[parameters.callbackId];
                        }
                        deferred.reject(e);
                    }
                    break;
                }
            }
            //如果不存在关键key那么直接返回执行成功的承诺
            if (!exist) {
                deferred.resolve();
            }
            //返回承诺
            return deferred.promise;
        }

        //封装js调用原生方法
        angular.extend(this, {
            //分享
            //type: 1(微信好友) 2(朋友圈) 3(qq好友)
            //obj: {title,descr,url,thumbURL,type}
            share: function (obj) { nativeTask(nativeFunctionsEnum.share, obj); },
            //根据菜单选择性分享
            shareMenu: function (obj) { nativeTask(nativeFunctionsEnum.shareMenu, obj); },
            //收藏成功
            collectionSucceed: function () { nativeTask(nativeFunctionsEnum.collectionSucceed, null); },
            //取消收藏成功
            cancelCollectionSucceed: function () { nativeTask(nativeFunctionsEnum.cancelCollectionSucceed, null); },
            //{string}
            copy: function (obj) { nativeTask(nativeFunctionsEnum.copy, obj); },
            //获取token
            token: function () { return nativeTask(nativeFunctionsEnum.token, null, true) },
            //返回页面
            back: function () { nativeTask(nativeFunctionsEnum.back, null); },
            //跳转登录页面
            login: function () { return nativeTask(nativeFunctionsEnum.login, null); },
            //普通购买页面obj: {title, imageUrl, price, prodId, isNeedAddress}
            purchase: function (obj) { return nativeTask(nativeFunctionsEnum.purchase, obj); },
            //{QQ}
            qqService: function (obj) { return nativeTask(nativeFunctionsEnum.qqService, obj || { QQ: '2852273072' }); },
            //{url: url}
            navigateToWebView: function (obj) { return nativeTask(nativeFunctionsEnum.navigateToWebView, obj); },

            articleBarInitData: function (obj) { return nativeTask(nativeFunctionsEnum.articleBarInitData, obj); },
            //显示评论条
            keyboardBarShow: function () { return nativeTask(nativeFunctionsEnum.keyboardBarShow, null); },
            //隐藏评论条
            keyboardBarHide: function () { return nativeTask(nativeFunctionsEnum.keyboardBarHide, null); },
            //新闻
            callNativeWebviewWithURL: function (obj) { return nativeTask(nativeFunctionsEnum.callNativeWebviewWithURL, obj); },
            //广告
            callNativeWebviewWithURLWithNaviBar: function (obj) { return nativeTask(nativeFunctionsEnum.callNativeWebviewWithURLWithNaviBar, obj); },
            //评论数减一
            keyboardBarShowUpdateCommentCountDecrement: function () { return nativeTask(nativeFunctionsEnum.keyboardBarShowUpdateCommentCountDecrement, null); },
            //附件展示
            callNativeAttachmentShow: function (obj) { return nativeTask(nativeFunctionsEnum.callNativeAttachmentShow, obj); },
            //导航条的隐藏或展示
            callNativeNaviBarState: function () { return nativeTask(nativeFunctionsEnum.callNativeNaviBarState, null); },
            //图片预览时隐藏显示原生头尾
            changeBarViewsState: function (obj) { return nativeTask(nativeFunctionsEnum.changeBarViewsState, obj, true); },
            //appUniqueUUID
            getAppUniqueUUID: function (obj) { return nativeTask(nativeFunctionsEnum.getAppUniqueUUID, null, true); },
            //图片浏览时保存图片到手机
            saveImgToClient: function (obj) { return nativeTask(nativeFunctionsEnum.saveImgToClient, obj, true) },
            //获取文章详情信息
            getNewsDetailInfo: function (obj) { return nativeTask(nativeFunctionsEnum.getNewsDetailInfo, obj, true) },
            //调用原生图片浏览
            showMagnifiedPic: function (obj) { return nativeTask(nativeFunctionsEnum.showMagnifiedPic, obj) },
            //调用原生发票扫描页
            showScanCode: function () { return nativeTask(nativeFunctionsEnum.showScanCode, null); },
            //H5页面滑动到顶部
            slideToTop: function () { return nativeTask(nativeFunctionsEnum.slideToTop, null); },
            //H5页面滑动到底部
            slideToBot: function () { return nativeTask(nativeFunctionsEnum.slideToBot, null); },
            //显示奖励
            showReward: function (obj) { return nativeTask(nativeFunctionsEnum.showReward, obj); },
            //留言页面 评论获取焦点
            commentBarFocus: function (obj) { return nativeTask(nativeFunctionsEnum.commentBarFocus, obj); },
            //留言页面 评论条显示
            goToCommentPage: function (obj) { return nativeTask(nativeFunctionsEnum.goToCommentPage, obj); },
            //跳转到课程列表
            goToCouseListPage: function (obj) { return nativeTask(nativeFunctionsEnum.goToCouseListPage, obj); },
            //更新文章评论数
            //{文章编号：id: fromId,  count:1}
            editNewsCmts: function (obj) { return nativeTask(nativeFunctionsEnum.editNewsCmts, obj) },
            //键盘弹出
            keyboardShow:function() { return nativeTask(nativeFunctionsEnum.keyboardShow, null) }
        });
    }])
})(window);

/// <reference path="../lib/angular.min.js" />
/// <reference path="../lib/jweixin-1.0.0.js" />
/// <reference path="../lib/qqapi.js" />

(function (win) {
    angular.module("h5ShareServicesModule", ["endServicesModule", "frontServicesModule"])
    .service("wxShareService", ["$http", "getWXTicketService", "locationFrontService", "appLogEndService", function ($http, getWXTicketService, locationFrontService, appLogEndService) {

        function setWxConfig(obj) {
            var shareUrl = win.location.href;
            if (shareUrl.indexOf('&') > -1) {
                shareUrl = shareUrl.replace(/&/g, "|");
            } else if (shareUrl.indexOf('#') > -1) {
                shareUrl = shareUrl.split('#')[0];
            }

            //jssdk 相关
            var Jparagram = {

                url: shareUrl,


            };
            getWXTicketService.getWXTicket(Jparagram).success(function (data) {
                console.log("callBak" + data);
                if (data != "" && data.Data) {
                    var Model = data.Data;
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: Model.appId, // 必填，公众号的唯一标识
                        timestamp: Model.timestamp, // 必填，生成签名的时间戳
                        nonceStr: Model.nonceStr, // 必填，生成签名的随机串
                        signature: Model.signature,// 必填，签名，见附录1
                        jsApiList: [
                            'onMenuShareAppMessage',
                            'onMenuShareTimeline',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });

                    wxSet(obj);
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，
                    //具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    wx.error(function (res) {
                        console.log(res);
                    });
                }
            });
        }
        function wxSet(obj) {
            //obj.url = obj.url.match(/([^&]*)/)[0]
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
            //所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            var shareSuccess = function () {
                if (typeof win.onShareSuccess == "function") { win.onShareSuccess(); }
            };
            var shareFail = function () {
                if (typeof win.onShareFail == "function") { win.onShareFail(); }
            }
            wx.ready(function () {
                // 在这里调用 API
                // 分享给朋友
                wx.onMenuShareAppMessage({
                    title: obj.title, // 分享标题
                    desc: obj.descr, // 分享描述
                    link: obj.url, // 分享链接
                    imgUrl: obj.thumbURL, // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        shareSuccess();
                        submitShareTime(obj);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        shareFail();
                    }
                });

                // 分享到朋友圈
                wx.onMenuShareTimeline({
                    title: obj.title, // 分享标题
                    desc: obj.descr, // 分享描述
                    link: obj.url, // 分享链接
                    imgUrl: obj.thumbURL, // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        shareSuccess();
                        submitShareTime(obj);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        shareFail();
                    }
                });

                wx.onMenuShareQQ({
                    title: obj.title, // 分享标题
                    desc: obj.descr, // 分享描述
                    link: obj.url, // 分享链接
                    imgUrl: obj.thumbURL, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        shareSuccess();
                        submitShareTime(obj);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        shareFail();
                    }
                });

                wx.onMenuShareWeibo({
                    title: obj.title, // 分享标题
                    desc: obj.descr, // 分享描述
                    link: obj.url, // 分享链接
                    imgUrl: obj.thumbURL, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        shareSuccess();
                        submitShareTime(obj);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数 
                        shareFail();
                    }
                });

                wx.onMenuShareQZone({
                    title: obj.title, // 分享标题
                    desc: obj.descr, // 分享描述
                    link: obj.url, // 分享链接
                    imgUrl: obj.thumbURL, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        shareSuccess();
                        submitShareTime(obj);
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                        shareFail();
                    }
                });
            });
        }

        function shareQQ(obj) {
            if (typeof obj == "object") {
                win.mqq.invoke("data", "setShareInfo", {
                    share_url: obj.url,
                    title: obj.title,
                    desc: obj.descr,
                    image_url: obj.thumbURL,
                    callback: function (data) {
                        submitShareTime(obj);
                    }
                });
            }
        }
        function submitShareTime(obj) {
            if (obj.url.indexOf("newsDetail.html") > 0 || obj.url.indexOf("topNewsDetail.html") > 0 || obj.url.indexOf("booksDetail.html") > 0 || obj.url.indexOf("courseDetail.html") > 0) {
                appLogEndService.submitViewLog({ url: obj.url });
            }
        }

        //统一提交分享记录数据
        function submitShare(obj) {
            appLogEndService.submitViewLog(obj);
        }
        //封装js调用分享方法
        angular.extend(this, {
            //分享
            //obj: {title,descrr,url,thumbURL,type}
            share: function (obj) { setWxConfig(obj); },
            shareQQ: function (obj) { shareQQ(obj); }
        });
    }])

})(window);

